import { DropDownInput } from "../../components/_input/_dropdown";
import { useState, useEffect, useContext, useCallback, useRef } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import config from "../../configuration/config";
import Popup from "../../User/popup";
import ConfirmContext from "../../utils/confirmContext";
import { useHistory } from "react-router";
import BranchesInfo from "../cart/component/BranchInfo";
// import DatePicker from 'react-datepicker';
import ErrorLabel from "../../components/error";
import { getData, User_Data_Key, saveData } from "../../utils/localStorageManager";
import _, { concat, sum, includes } from "lodash";
import { GetMessages, formValidate } from "../../utils/validation";
import Joi from "joi";
import { RadioInputDynamic } from "../../components/_input/_radioInputDynamic";
import { toast } from "react-toastify";
import moment from "moment";
import SectionHeading from "../../components/sectionHeading";
import { InputField } from "../../components/_input/_input";
import { TextArea } from "../../components/_input/_textArea";
import { Price } from "../../components/__simple/_price";
import { numberFormat } from "../../utils/currencyFormatter";
import ExitPromptHandler from "../../components/ExitPromptHandler";
import CounterOnEnd from "../../components/CounterOnEnd";
import { CheckInput } from "../../components/_input/_checkInput";
import AgreementViewer from "./AgreementViewer";
import OTPCheck from "./components/OTPCheck";
import StepProgressBar from "../../components/StepProgressBar";
import { DatePicker, Space } from "antd";
import dayjs from "dayjs";
import useTrackBeginCheckout from "../../hooks/useTrackBeginCheckout";
import useTrackCompletesBookingVehicle from "../../hooks/useTrackCompletesBookingVehicle";
// import useTrackAddPaymentInfo from "../../hooks/useTrackAddPaymentInfo";
import useTrackAddShippingInfo from "../../hooks/useTrackAddShippingInfo";
// import { Prompt } from "react-router-dom";
export function CarCheckoutCashPage({ vehicle, parmActiveModel, isToyota, isLexus, selectedColor, finance, financeSettings, filterCarImages, ServiceParm }) {
  const { t: trans, i18n } = useTranslation(["new", "finance", "inputs", "info", "cart", "extra", "form"]);
  let lang = i18n.language || "ar";
  const subFunctionRef = useRef(null);
  const subOTPCheckYakeenDataFunctionRef = useRef(null);
  const thisConfirmContext = useContext(ConfirmContext);
  const location = useLocation();
  const history = useHistory();
  const [showFinalPopupMessage, setShowFinalPopupMessage] = useState();
  const { slug, sn } = useParams();
  const [isLoadingSendOrder, setLoadingSendOrder] = useState(false);
  const [sadadInfo, setSadadInfo] = useState(null);
  const [carInfo, setCarInfo] = useState(null);
  const [activeModel, setActiveModel] = useState(parmActiveModel);
  const [dataFullNum, setDataFullNum] = useState(0);
  const [stepNum, setStepNum] = useState(1);
  const [dataInitializeOrder, setDataInitializeOrder] = useState(null);
  const [dataFinalPopup, setDataFinalPopup] = useState({});
  const [showFinalPopup, setShowFinalPopup] = useState(false);
  const [showStstusLodingPopup, setShowStstusLodingPopup] = useState(false);
  const [showOTPCheckPopup, setShowOTPCheckPopup] = useState(false);
  const [noteAccessories, setNoteAccessories] = useState("");
  const [requestForm, setRequestForm] = useState({ selectedNationality: "SAU" });
  const [checkoutAgreemnt, setChecAgreemnt] = useState(false);
  const [checkoutAbsherOtp, setCheckoutAbsherOtp] = useState(false);
  const [isLoadingYakeen, setLoadingYakeen] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const allowCustGroups = ["G4", "G3"];
  const query = new URLSearchParams(location.search);
  const [orderDraftID, setOrderDraftID] = useState(query.get("orderDraftID")?.trim());
  const [isReservation, setIsReservation] = useState(query.get("isReservation") && query.get("isReservation") !== "false");
  const [paymentType, setPaymentType] = useState(null);
  const [VerificationCode, setVerificationCode] = useState(null);
  const [error, setError] = useState({});
  const [showOTPCheckYakeenDataPopup, setShowOTPCheckYakeenDataPopup] = useState(false);

  useTrackCompletesBookingVehicle({
    orderData: dataFinalPopup,
    car: carInfo,
    currency: "SAR",
    creativeSlot: "Checkout_Cash_Page",
  });

  const schema_1 = Joi.object({
    name: Joi.string().required().messages(GetMessages()),
    phoneNumber: Joi.string().min(12).required().messages(GetMessages()),
    // City: Joi.string().required().messages(GetMessages()),
    accountType: Joi.string().required().messages(GetMessages()),
    identity: Joi.string().min(10).required().messages(GetMessages()),
    // commercialIdentity: Joi.string().min(10).required().messages(GetMessages()),
    DateOfBirth: Joi.date().required().messages(GetMessages()),
    checkoutAgreemnt: Joi.bool().required().equal(true).messages(GetMessages()),
  });
  const schema_2 = Joi.object({
    develviryType: Joi.number().required().messages(GetMessages()),
    develviryBranch: Joi.string().required().messages(GetMessages()),
    develviryCity: Joi.string().required().messages(GetMessages()),
  });
  const schema_3 = Joi.object({
    checkoutAbsherOtp: Joi.bool().required().equal(true).messages(GetMessages()),
    OTP: Joi.string().required().messages(GetMessages()),
  });

  const schema_4 = Joi.object({
    paymentType: Joi.string().required().messages(GetMessages()),
  });
  const schema_PersonalData = Joi.object({
    identity: Joi.string().min(10).required().messages(GetMessages()),
    DateOfBirth: Joi.any().required().messages(GetMessages()),
    checkoutAgreemnt: Joi.bool().required().equal(true).messages(GetMessages()),
  });
  const [propsData, setPropsData] = useState({});
  const [checkoutType, setCheckoutType] = useState(null);

  const [TotalTax, SetTotalTax] = useState(0);
  const [TotalDiscount, SetTotalDiscount] = useState(0);
  const [SumItemTotal, setSumItemTotal] = useState(0);
  const [SubTotal, setSubTotal] = useState(0);
  const [fullTotal, setfullTotal] = useState(0);
  const [MiniDownPayment, setMiniDownPayment] = useState(0);
  const [accountTypes, setAccountTypes] = useState([]);

  const [isClientAccount, setIsClientAccount] = useState(null);
  //-----------------------
  const [allServiceID, setAllServiceID] = useState([]);
  const [Service, setService] = useState(null);
  const [serviceImportantAdditions, setServiceImportantAdditions] = useState(null);
  const [indexPanel, setIndexPanel] = useState("1000");
  const [acticeService, setActiceService] = useState(null);
  const [evaluations, setEvaluations] = useState({
    evaluation_false_0: 0,
    evaluation_false_1: 0.2,
    evaluation_false_2: 0.2,
    evaluation_false_3: 0.2,
    evaluation_true_0: 0.2,
  });

  const citiesYageen = [
    { label: "Riyadh", value: "Riyadh-SAU" },
    { label: "Jeddah", value: "Jeddah-SAU" },
    { label: "Mecca", value: "Mecca-SAU" },
    { label: "Medina", value: "Medina-SAU" },
    { label: "Dammam", value: "Dammam-SAU" },
    { label: "Khobar", value: "Khubar-SAU" },
    { label: "Dhahran", value: "Dhahran-SAU" },
    { label: "Tabuk", value: "Tabuk-SAU" },
    { label: "Hail", value: "Hail-SAU" },
    { label: "Buraidah", value: "Buraidah-SAU" },
    { label: "Al Ahsa", value: "AlAhsa-SAU" },
    { label: "Abha", value: "Abha-SAU" },
    { label: "Khamis Mushait", value: "KhamisMushait-SAU" },
    { label: "Najran", value: "Najran-SAU" },
    { label: "Jazan", value: "Jazan-SAU" },
    { label: "Yanbu", value: "Yanbu-SAU" },
    { label: "Al Qassim", value: "Qassim-SAU" },
    { label: "Al Jouf", value: "Jouf-SAU" },
    { label: "Al Baha", value: "Baha-SAU" },
    { label: "Arar", value: "Arar-SAU" },
    { label: "Sakaka", value: "Sakaka-SAU" },
    { label: "Al Majmaah", value: "Majmaah-SAU" },
    { label: "Al Khafji", value: "Khafji-SAU" },
    { label: "Rafha", value: "Rafha-SAU" },
    { label: "Wadi Al Dawasir", value: "WadiDawasir-SAU" },
    { label: "Al Qurayyat", value: "Qurayyat-SAU" },
    { label: "Taif", value: "Taif-SAU" },
    { label: "Hofuf", value: "Hofuf-SAU" },
    { label: "Bisha", value: "Bisha-SAU" },
    { label: "Al Kharj", value: "Kharj-SAU" },
    { label: "Al Lith", value: "Lith-SAU" },
    { label: "Al Ula", value: "Ula-SAU" },
  ];
  function normalizeCityName(name) {
    return name.toLowerCase().replace(/\s+/g, "").replace(/al/i, "");
  }
  const GetCityCodeByYagenCityName = (customerCityName) => {
    if (customerCityName) {
      const normalizedCustomerCity = normalizeCityName(customerCityName);
      const matchedCity = citiesYageen.find((city) => normalizeCityName(city.label).includes(normalizedCustomerCity));
      if (matchedCity) {
        return matchedCity.value;
      } else {
        return null;
      }
    }
  };
  const [allselectServices, setAllSelectServices] = useState([]);

  useEffect(() => {
    //اجراء التاكد من حالة الدفع وتحديث حقل isPayment
    //Site_Carts_PaymentStatus
    const fetchPaymentStatus = async () => {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var id = query.get("OrderGUID")?.trim();
      if (!id) return;

      setShowStstusLodingPopup(true);
      try {
        const response = await axios.post(`${config.controllURL}api/Payment/CarPaymentStatus`, null, {
          headers: myHeaders,
          params: { ID: id },
          responseType: "json",
        });

        const responseData = response?.data;

        setShowStstusLodingPopup(false);

        if (!responseData) return;

        let data = Array.isArray(responseData) ? responseData.find((p) => p.Status === "success" || p.Status === "notPaid") || responseData[0] : responseData;

        if (!data) return;
        if (data.Status === "notPaid") {
          setShowFinalPopup(true);
          setShowFinalPopupMessage(trans("new:Payment_was_not_completed_Purchase_process_failed"));

          return;
        }

        if (data.Status === "success") {
          if (data?.SadadNumber) setSadadInfo(data.SadadNumber);
          setShowFinalPopup(true);
          setDataFinalPopup(data);
        } else if (data?.ResponseText) {
          try {
            const jsonData = JSON.parse(data.ResponseText);
            // console.log("IsSuccess:", jsonData.IsSuccess);
            // console.log("InvoiceStatus:", jsonData.Data?.InvoiceStatus);

            if (jsonData.IsSuccess == true && jsonData.Data?.InvoiceStatus) {
              setShowFinalPopup(true);
              setShowFinalPopupMessage(trans("new:Payment_was_not_completed_Purchase_process_failed"));
              data["InvoiceStatus"] = jsonData.Data?.InvoiceStatus;
              setDataFinalPopup(data);
            }
          } catch (error) {
            console.error("Invalid JSON:", error);
          }
        } else if (data?.ErrorMessage) {
          alert(`${data.ErrorMessage} / ${data?.ErrorProcedure || ""}`);
        }
      } catch (error) {
        console.error("Error fetching payment status:", error);
      }
    };

    // استدعاء الدالة عند الحاجة
    fetchPaymentStatus();

    // if (orderDraftID) {
    //   setPaymentType("Myfatoorah&SADAD");
    //   const val = { ...requestForm };
    //   val.paymentType = "Myfatoorah&SADAD";
    //   setRequestForm(val);
    // }
  }, []);

  useEffect(() => {
    const parent = document.querySelector(".App");

    const handleScroll = () => {
      if (parent) {
        if (window.scrollY > 30) {
          parent.style.overflow = "visible"; // Enable when scrolling
        } else {
          parent.style.overflow = "hidden"; // Reset when at the top
        }
      }
    };

    // Attach scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup function
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (parent) {
        parent.style.overflow = ""; // Reset when unmounting
      }
    };
  }, []);
  const cachName = "checkoutCash_" + sn + "_" + slug;
  useEffect(() => {
    if (ServiceParm && ServiceParm.length > 0) {
      setService(ServiceParm);
    }
  }, [ServiceParm]);
  //-----------------------
  useEffect(() => {
    async function fetchData() {
      await handelGetCachData();

      axios
        .post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/SiteGetUserAccountTypes`, {})
        .then((response) => {
          ////// console.log("accountType", response.data);
          setAccountTypes(response?.data?.filter((c) => allowCustGroups?.includes(c.ID)));
        })
        .catch((err) => {
          //// console.log(err);
        });
      // ...
    }
    fetchData();
  }, []);
  const [platformTypes, setPlatformTypes] = useState([]);

  useEffect(() => {
    // تحميل الملف من مجلد public
    const loadManifest = async () => {
      try {
        const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        // Filter and map to extract keys with isActive = true
        var platformsTypes = data.platformsTypes || [];
        const activeKeys = platformsTypes.filter((platform) => platform.isActive).map((platform) => platform.key);

        //// console.log("Active keys:", activeKeys);

        setPlatformTypes(activeKeys);
      } catch (error) {
        console.error("Error loading manifest.json:", error);
      }
    };

    loadManifest();
  }, []);
  const timeoutOTPCheckYakeenDataFunctionRef = useRef(null); // مرجع لتخزين معرف المؤقت
  const isMountedOTPCheckYakeenDataRef = useRef(true);
  useEffect(() => {
    isMountedOTPCheckYakeenDataRef.current = true;
    return () => {
      isMountedOTPCheckYakeenDataRef.current = false;
      if (timeoutOTPCheckYakeenDataFunctionRef.current) {
        clearInterval(timeoutOTPCheckYakeenDataFunctionRef.current);
        timeoutOTPCheckYakeenDataFunctionRef.current = null;
      }
    };
  }, []);

  const handleRunSubOTPCheckYakeenDataFunction = useCallback((VerificationCode, identityNumber) => {
    if (!isMountedOTPCheckYakeenDataRef.current) return;

    if (timeoutOTPCheckYakeenDataFunctionRef.current) {
      clearInterval(timeoutOTPCheckYakeenDataFunctionRef.current);
      timeoutOTPCheckYakeenDataFunctionRef.current = null;
    }

    if (subOTPCheckYakeenDataFunctionRef.current) {
      // console.log("OTPCheck has current.");
      subOTPCheckYakeenDataFunctionRef.current(VerificationCode, identityNumber);
    } else {
      // console.log("OTPCheck not has current.");
      let attempts = 0;
      timeoutOTPCheckYakeenDataFunctionRef.current = setInterval(() => {
        if (!isMountedOTPCheckYakeenDataRef.current) {
          // console.log("OTPCheck clearInterval timeoutOTPCheckYakeenDataFunctionRef.");
          clearInterval(timeoutOTPCheckYakeenDataFunctionRef.current);
          timeoutOTPCheckYakeenDataFunctionRef.current = null;
          return;
        }

        attempts++;
        if (subOTPCheckYakeenDataFunctionRef.current) {
          // console.log("OTPCheck subOTPCheckYakeenDataFunctionRef SND>>>> VerificationCode");
          subOTPCheckYakeenDataFunctionRef.current(VerificationCode, identityNumber);
          clearInterval(timeoutOTPCheckYakeenDataFunctionRef.current);
          timeoutOTPCheckYakeenDataFunctionRef.current = null;
        } else if (attempts >= 5) {
          // console.log("OTPCheck not ready after 5 seconds.");
          clearInterval(timeoutOTPCheckYakeenDataFunctionRef.current);
          timeoutOTPCheckYakeenDataFunctionRef.current = null;
        }
      }, 1000);
    }

    setShowOTPCheckYakeenDataPopup(true);
  }, []);

  const SendAbsherTPCheckYakeenData = async () => {
    console.log("personalDataRequest", personalDataRequest);
    console.log("requestForm", requestForm);
    var newError = { ...error };
    if (personalDataRequest?.identity && requestForm?.identity != personalDataRequest?.identity) {
      newError["identity"] = "يجب ادخال رقم الهوية المرتبطة بالحساب";
      setError(newError);
      return;
    }

    newError["identity"] = null;
    setError(newError);
    if (isSending) return; // منع التكرار

    setIsSending(true); // قفل الإرسال

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var identityNumber = requestForm?.identity;
    var raw = {
      identityNumber: identityNumber,
      lang: lang,
      custID: "جلب المعلومات الشخصية",
    };

    // //test- فقط في وضع الدفلوبر-------------
    // if (process.env.NODE_ENV === "development") {
    //   handleRunSubOTPCheckYakeenDataFunction(null,identityNumber);
    //   setIsSending(false);
    //   return;
    // }
    // //test--------------

    try {
      const response = await axios.request({
        url: "https://appw.hassanjameelapp.com/api/Payment/site_SendAbsherOtpOnly",
        headers: myHeaders,
        data: raw,
        method: "POST",
        responseType: "json",
      });

      const responseData = response?.data;
      let PersonalData = Array.isArray(responseData) ? responseData.find((p) => p.status == 1) : null;
      // PersonalData.verificationCode=null;
      if (PersonalData) {
        handleRunSubOTPCheckYakeenDataFunction(PersonalData.verificationCode, identityNumber);
      } else {
        console.error("responseData:", responseData);
        toast.warn(trans("new:confirmation_code_error"));
      }
    } catch (error) {
      toast.warn(trans("new:invalid_data"));
      console.error("SendAbsherOtp error:", error);
      setIsSending(false); // فتح القفل
    }

    setIsSending(false); // فتح القفل
    setLoadingYakeen(false);
  };
  const timeoutRef = useRef(null); // مرجع لتخزين معرف المؤقت

  const handleRunSubOTPCheckFunction = useCallback(
    (VerificationCode, identityNumber) => {
      // إذا كان المؤقت السابق قيد التشغيل، قم بإلغائه
      if (timeoutRef.current) {
        clearInterval(timeoutRef.current);
        timeoutRef.current = null;
      }

      if (subFunctionRef.current) {
        // console.log("Running subFunction immediately...");
        subFunctionRef.current(VerificationCode,identityNumber);
      } else {
        console.warn("SMSCheck is not initialized yet! Waiting for 5 seconds...");

        let attempts = 0;
        timeoutRef.current = setInterval(() => {
          attempts++;

          if (subFunctionRef.current) {
            // console.log("SMSCheck loaded! Running subFunction...");
            subFunctionRef.current(VerificationCode,identityNumber);
            clearInterval(timeoutRef.current); // إيقاف المؤقت عند نجاح العملية
            timeoutRef.current = null; // إعادة تعيين المرجع
          } else if (attempts >= 5) {
            console.warn("Timeout reached! SMSCheck was not initialized in time.");
            clearInterval(timeoutRef.current);
            timeoutRef.current = null;
          }
        }, 1000); // تحقق كل ثانية لمدة 5 ثوانٍ
      }

      setShowOTPCheckPopup(true);
    },
    [subFunctionRef],
  );

  var currentSize = 0;
  const CategoryCar = (Category) => {
    if (Size != currentSize) {
      currentSize = Category;
      SetSize(Category);
    }
  };
  const refrechDateCartItems = async (carInfo) => {
    Account(carInfo);
  };

  const handelSetRequestForm = useCallback(
    (newData) => {
      //// console.log("handelSetRequestForm>>>>>>>>>>>>>>:", newData);
      //// console.log("requestForm>>>>>>>>>>>>>>:", requestForm);
      setRequestForm((prevRequestForm) => ({
        ...prevRequestForm,
        ...newData,
      }));
    },
    [requestForm],
  );

  const [personalDataRequest, setPersonalDataRequest] = useState({
    arFirstName: "",
    arMiddleName: "",
    arLastName: "",
    enFirstName: "",
    enMiddleName: "",
    enLastName: "",
    genderID: "",
    address: "",
    cityID: "",
    countryID: "",
    logo: "",
  });
  const handelSetPersonalData = useCallback(() => {
    // You can await here
    const isLogin = getData("isAuthenticated");
    if (isLogin) {
      const userData = JSON.parse(getData(User_Data_Key, true));
      // console.log("userData>>>>>>>>>>>>>>>>:", userData);
      if (userData) {
        setPersonalDataRequest(userData);
        var name =
          lang == "ar"
            ? (userData?.arFirstName ?? "" + " " + userData?.arMiddleName ?? "" + " " + userData?.arLastName ?? "")
            : (userData?.enFirstName ?? "" + " " + userData?.enMiddleName ?? "" + " " + userData?.enLastName ?? "");
        userData["name"] = name;

        const val = {};
        val.name = name;

        // const match = userData?.phone.match(/^(\+\d{1,4})(\d+)$/);

        const mainNumber = userData?.phone?.slice(-9); // Last 9 digits, e.g., 530005261
        // Get everything before the last 9 digits as the country code
        const countryCode = userData?.phone?.slice(0, -9);
        val.phoneNumberCode = countryCode.replace("+", "");
        val.phoneNumberOnly = mainNumber;
        val.phoneNumber = userData?.phone ? userData?.phone : "";
        val.accountType = userData?.custGroupID && allowCustGroups.includes(userData?.custGroupID) ? userData?.custGroupID : allowCustGroups[0];
        val.isClientAccount = val.accountType === "G4" ? true : false;
        setIsClientAccount(val.isClientAccount);
        val.identity = userData?.identity ? userData?.identity : "";
        val.commercialIdentity = userData?.tradeNo ? userData?.tradeNo : "";
        val.address = userData?.address ?? "";
        val.City = userData?.cityID ?? "";
        handelSetRequestForm(val);
      }
    } else {
      sn &&
        slug &&
        history.push({
          pathname: `/car/checkout/${sn}/${slug}`,
          search: "",
        });
      thisConfirmContext.onShowRegistrationPup(true);
    }

    // ...
  }, [allowCustGroups, handelSetRequestForm, lang, requestForm]);

  useEffect(() => {
    async function fetchData() {
      if (carInfo) {
        CategoryCar(carInfo?.groupID);
        await refrechDateCartItems(carInfo);
      }
      // ...
    }
    fetchData();
  }, [carInfo]);
  //Accounting for all items
  function Account(p) {
    p.quantity = 1;
    let currentTotalTax = (100 / 115) * ((p.MiniDownPayment ? p.MiniDownPayment : p.NetSalePrice) * p.quantity) * 0.15;

    SetTotalTax(currentTotalTax);

    let currentTotalDiscount = calculateDiscount(p);
    SetTotalDiscount(currentTotalDiscount);

    let currentSumItemTotal = (p.MiniDownPayment ? p.MiniDownPayment : p.NetSalePrice) * p.quantity;

    setSumItemTotal(currentSumItemTotal);
    let currentSumfullTotal = p.NetSalePrice * p.quantity;

    setfullTotal(currentSumfullTotal);
    let currentSubTotal = (p.MiniDownPayment ? p.MiniDownPayment : p.NetSalePrice) * p.quantity;
    setSubTotal(currentSubTotal);

    let currentMiniDownPayment = p.MiniDownPayment && p.MiniDownPayment != 0 ? p.MiniDownPayment * p.quantity : (p.MiniDownPayment ? p.MiniDownPayment : p.NetSalePrice) * p.quantity;
    setMiniDownPayment(currentMiniDownPayment);
  }
  // calculate discount
  const calculateDiscount = (itemInfo) => {
    let discountResult = [];
    try {
      if (couponDetail?.items) {
        //console.log(itemInfo);
        discountResult = couponDetail?.items.map((item) => {
          let result = 0;
          const { BrandID: brand, groupID, modelTypes, miniDownPayment, minPrice, quantity } = itemInfo;
          if (brand == item?.brandID && groupID === item?.productGroupID && modelTypes === item?.productModelTypeID) {
            result = getDiscountValueByType(item, minPrice, quantity);
          }

          return result;
        });
      }
    } catch (error) {
      //console.log(error);
    }
    return sum(discountResult) ?? 0;
  };

  //-----------------------------------------------
  const [couponDetail, setCouponDetail] = useState(null);
  const [clearCoupon, setClearCoupont] = useState(false);
  //to apply the coupon discount on the cart
  const applyCoupon = (code) => {
    const _id = getData("secretKey");
    if (code) {
      if (_id) {
        axios
          .request({
            baseURL: config.controllURL,
            url: lang + "/api/cart/CouponDetails",
            method: "post",
            data: {
              couponCode: code,
              id: _id,
            },
          })
          .then((response) => {
            const responseData = response.data;
            if (responseData?.items?.length > 0) {
              setCouponDetail(responseData);
              setClearCoupont(true);
            } else {
              setCouponDetail(null);
              setClearCoupont(false);
            }
          })
          .catch((error) => {
            //console.log(error);
          });
      } else {
        // toast.error(trans("new:login_first"));
        thisConfirmContext.onShowRegistrationPup(true);
      }
    } else {
      SetTotalDiscount(0);
    }
  };

  // apply discount by type
  const getDiscountValueByType = (item, price, quantity) => {
    let result = 0;
    const { discountType, discountAmount, discountRate } = item;
    if (discountType?.toLowerCase() === "amount") {
      const discountValue = discountAmount * quantity;
      result = discountValue;
    } else if (discountType?.toLowerCase() === "rate") {
      const priceRateValue = price * quantity * (discountRate / 100);
      result = priceRateValue;
    }
    return result;
  };
  useEffect(() => {
    handleFetchCountries();
    GetBranch();
  }, []);
  useEffect(() => {
    //console.log("props:", propsData);
    var mm = {
      ...propsData,
      vehicle,
      isToyota,
      isLexus,
      selectedColor,
      finance,
      financeSettings,
      filterCarImages,
    };
    setPropsData(mm);

    var reservMiniDownPayment = (isToyota && isToyota) ? 2500 : isLexus ? 5000 : selectedColor?.MiniDownPayment;
    var newMiniDownPayment = selectedColor?.MiniDownPayment > reservMiniDownPayment ? reservMiniDownPayment : selectedColor?.MiniDownPayment;

    if (selectedColor) setCarInfo({ ...selectedColor, MiniDownPayment: newMiniDownPayment });
  }, [vehicle, isToyota, isLexus, selectedColor, finance, financeSettings, filterCarImages]);
  useEffect(() => {
    // console.log("parmActiveModel:", parmActiveModel);
    setActiveModel(parmActiveModel);
  }, [parmActiveModel]);
  useEffect(() => {
    var id = query.get("OrderGUID")?.trim();
    if (id) return;
    //// console.log("activeModel:", activeModel);
    if (activeModel && activeModel?.buyOnline != true) {
      setShowFinalPopupMessage(trans("new:chassisReserved"));
      setShowFinalPopup(true);
    }
  }, [activeModel]);

  const [Shipping, setShipping] = useState({ UnitTime: "", CountTime: 0, Cost: 0, CostWithTax: 0, DateTimeDelevry: "" });
  const [dataShippingInfo, setDataShippingInfo] = useState({ "": [] });
  const [selectcity, setSelectcity] = useState(null);
  const [develviryType, setDeleviryType] = useState(0);
  const [ValueCitie, setValueCitie] = useState("");
  const [Size, SetSize] = useState(0);
  const [currentDeliveryMethod, setcurrentDeliveryMethod] = useState({
    branchMethod: false,
    locationMethod: true,
  });
  const [ValueBranch, setValueBranch] = useState("");
  function getValueBranch(option) {
    setValueBranch(option.value);

    const val = { ...requestForm };
    val.develviryBranch = option.value;
    setRequestForm(val);
  }
  const [Branches, setBranches] = useState([]);
  const [branchesDetails, setBranchesDetails] = useState([]);
  async function GetBranch() {
    const Body = {};
    axios
      .request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_FetchVehicleBranches`,
        data: Body,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        const result = response.data;
        setBranches(result);
        const formatResult = result.map((item) => {
          return {
            title: concat(item[`${trans("model:description")}`], item.Address ? concat("-", item.Address) : ""),
            details: item.WorkingHoursFormat,
            lat: item.Latitude,
            long: item.Longitude,
          };
        });
        setBranchesDetails(formatResult);
      })
      .catch(function (error) {
        //console.log(error);
      });
  }

  async function CarShippingInfo(Citey, mSize) {
    setValueCitie(Citey.value);

    const val = { ...requestForm };
    val.develviryCity = Citey.value;
    setRequestForm(val);
    const Body = {
      City: `${Citey.value}`,
      categore: `${mSize}`,
    };
    await axios
      .request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/Site_CarShippingInfo`,
        data: Body,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        // //console.log(response.data.ApiObjectData);
        var currentvalue = { ...Shipping };
        currentvalue.Cost = response.data[0].CostShipping;
        currentvalue.CostWithTax = response.data[0].CostShippingWithTax;
        currentvalue.UnitTime = response.data[0].Type;
        currentvalue.CountTime = response.data[0].TimeDelivary;
        setShipping(currentvalue);
        //console.log(currentvalue);
      })
      .catch(function (error) {
        //console.log(error);
        var currentvalue = { ...Shipping };
        currentvalue.Cost = 0;
        currentvalue.CostWithTax = 0;
        currentvalue.UnitTime = trans("new:not_avilable");
        currentvalue.CountTime = null;
        setShipping(currentvalue);
        //console.log(currentvalue);
      });
  }

  useEffect(() => {
    async function fetchData() {
      // You can await here
      await checkStepsErrorsDataFullNum();
      // ...
    }
    fetchData();
  }, [requestForm, evaluations]);
  const cheangeSteps = async (step) => {
    if (
      step > 0 &&
      step <= 4 &&
      // && step < stepNum
      step != stepNum
    ) {
      const statusStep = await checkStepsErrors();
      if (statusStep >= step) {
        setStepNum(step);
      }
    }
  };

  //----------------------
  const [filteredCities, setFilteredCities] = useState([]);
  useEffect(() => {
    async function fetchData() {
      try {
        const settingsResponse = await axios.request({
          baseURL: config.controllURL,
          url: lang + "/api/user/getSettings",
          method: "get",
        });

        if (settingsResponse.status === 200) {
          var mm = settingsResponse?.data?.genders.map((e) => {
            return { value: String(e.id), text: e.description };
          });

          setFilteredCities(
            settingsResponse?.data?.cities?.filter((item) => {
              return item.code == "SAU";
            }),
          );
        }
      } catch (err) {
        //// console.log(err);
      }
      // ...
    }
    fetchData();
  }, [lang]);

  //ارسال انه تم بدا اتمام الطلب الى منصة التسويق الخارجية
  useTrackBeginCheckout({ car: carInfo });

  useTrackCompletesBookingVehicle({ orderData: dataFinalPopup, car: carInfo });
  //ارسال وسيلة الدفع المختارة
  // useTrackAddPaymentInfo({ car: carInfo, paymentType: paymentType });
  //ارسال وسيلة الشحن المختارة
  useTrackAddShippingInfo({ car: carInfo, shippingTier: develviryType === 1 ? "Delivery" : "Branch", stepNum: stepNum });

  //-------------------------------------------
  const [cities, setCities] = useState([]);
  // to fetch all SAU countries
  const handleFetchCountries = async () => {
    let countries = [];
    try {
      const response = await axios.post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_ShippingCities`, {});
      if (response.status == 200) {
        countries = response.data.map((item) => {
          return { value: item.ID, text: item[`${trans("model:description")}`] };
        });
      }
    } catch (error) {
      //console.log('error in fetching the countries of SAU', error);
    }
    setCities(countries);
  };
  //---------------------

  const checkStepsErrorsDataFullNum = async () => {
    var srempNumber = 0;

    console.log("checkStepsErrorsDataFullNum:", requestForm);
    var result = formValidate(schema_1, requestForm) ?? {};
    let otherProperities = [];
    let newErrors = {};
    const val = { ...requestForm };
    if (isClientAccount) {
      otherProperities = ["commercialIdentity"];
    } else {
      otherProperities = ["identity"];
    }
    newErrors = otherProperities ? removeUnspecificError(result, otherProperities) : result;

    if (Object.keys(newErrors).length === 0) {
      srempNumber = 1;
    } else {
      setDataFullNum(srempNumber);
      return srempNumber;
    }

    result = formValidate(schema_2, requestForm) ?? {};
    if (develviryType == 1) {
      otherProperities = ["develviryBranch"];
    } else {
      otherProperities = ["develviryCity"];
    }
    result = otherProperities ? removeUnspecificError(result, otherProperities) : result;

    if (Object.keys(result).length === 0) {
      srempNumber = 2;
    } else {
      setDataFullNum(srempNumber);
      return srempNumber;
    }

    if (!requestForm.OTP) {
      if (requestForm.verificationOTP == VerificationCode) {
        requestForm.OTP = requestForm.verificationOTP;
      } else {
      }
    }
    result = formValidate(schema_3, requestForm) ?? {};

    if (Object.keys(result).length === 0) {
      srempNumber = 4;
    } else {
      setDataFullNum(srempNumber);
      return srempNumber;
    }
    if (Object.keys(result).length === 0) {
      srempNumber = 4;
    } else {
      setDataFullNum(srempNumber);
      return srempNumber;
    }

    setDataFullNum(srempNumber);
    return srempNumber;
  };
  // to remove the unneeded props
  const removeUnspecificError = (errorList, values = []) => {
    let errorResult = {};
    if (values?.length > 0) {
      const lowerValues = values.map((item) => {
        return item.toLowerCase();
      });
      Object.assign(errorResult, errorList);
      if (errorList) {
        for (let index = 0; index < Object.keys(errorList).length; index++) {
          const key = Object.keys(errorList)[index];
          if (includes(lowerValues, key.toLowerCase())) {
            delete errorResult[key];
          } else {
            continue;
          }
        }
      }
    }
    return errorResult;
  };
  const checkStepsErrors = async (valForm = {}) => {
    var srempNumber = 0;

    var result = formValidate(schema_1, { ...requestForm, ...valForm }) ?? {};
    let otherProperities = [];
    let newErrors = {};
    if (isClientAccount) {
      otherProperities = ["commercialIdentity"];
    } else {
      otherProperities = ["identity"];
    }
    newErrors = otherProperities ? removeUnspecificError(result, otherProperities) : result;
    if (stepNum == 1) setError(newErrors);

    // console.log("requestForm>>>>>>>>>>>>>>:", requestForm);
    // console.log("newErrors>>>>>>>>>>>>>>:", result);

    if (Object.keys(result).length === 0) {
      srempNumber = 1;
    } else {
      setDataFullNum(srempNumber);
      setStepNum(srempNumber + 1);
      return srempNumber;
    }
    result = formValidate(schema_2, { ...requestForm, ...valForm }) ?? {};
    if (develviryType == 1) {
      otherProperities = ["develviryBranch"];
    } else {
      otherProperities = ["develviryCity"];
    }
    result = otherProperities ? removeUnspecificError(result, otherProperities) : result;
    // console.log("result222>>>>>>>>>>>>>>:", result);

    if (stepNum == 2) setError(result);

    if (Object.keys(result).length === 0) {
      srempNumber = 2;
    } else {
      setDataFullNum(srempNumber);
      setStepNum(srempNumber + 1);
      return srempNumber;
    }

    if (!valForm.OTP) {
      if (requestForm.verificationOTP == VerificationCode) {
        valForm.OTP = requestForm.verificationOTP;
      } else {
      }
    }
    result = formValidate(schema_3, { ...requestForm, ...valForm }) ?? {};
    // console.log("result333>>>>>>>>>>>>>>:", result);
    if (stepNum == 3) setError(result);

    if (Object.keys(result).length === 0) {
      srempNumber = 3;
    } else {
      setDataFullNum(srempNumber);
      setStepNum(srempNumber + 1);
      return srempNumber;
    }

    result = formValidate(schema_4, { ...requestForm, ...valForm }) ?? {};
    // console.log("result444>>>>>>>>>>>>>>:", result);
    // console.log("srempNumber>>>>>>>>>>>>>>:", srempNumber);
    if (stepNum == 4) setError(result);
    if (Object.keys(result).length === 0) {
      srempNumber = 4;
    } else {
      setDataFullNum(srempNumber);
      setStepNum(srempNumber + 1);
      return srempNumber;
    }

    setDataFullNum(srempNumber);
    return srempNumber;
  };

  const handlePayment = async (InitializeOrder = false) => {
    const isLogin = getData("isAuthenticated");
    if (isLogin) {
      const cleanData = JSON.parse(getData(User_Data_Key, true));
      //// console.log("handlePayment:", cleanData);
      const user_id = cleanData.id.toString().split("_")[1];
      if (user_id) {
        if (!currentDeliveryMethod?.locationMethod && !currentDeliveryMethod?.branchMethod) {
          toast.warn(trans("new:not_delivery_selected"));
        } else if (currentDeliveryMethod?.locationMethod && (ValueCitie == "" || ValueCitie == null)) {
          toast.warn(trans("new:not_delivery_selected_loc"));
        } else if (currentDeliveryMethod?.branchMethod && (ValueBranch == "" || ValueBranch == null)) {
          toast.warn(trans("new:not_delivery_selected_branch"));
        } else {
          await PaymentMAin(
            1,

            (currentDeliveryMethod?.locationMethod ?? false) ? ValueCitie : null,
            (currentDeliveryMethod?.branchMethod ?? false) ? ValueBranch : null,
            currentDeliveryMethod?.locationMethod ?? false,
            currentDeliveryMethod?.branchMethod ?? false,
            isReservation,
            !isReservation,
            MiniDownPayment,
            SumItemTotal,
            Shipping.Cost,
            SubTotal,
            TotalTax,
            TotalDiscount,
            //--------------
            [
              {
                id: carInfo?.ProductID,
                quantity: 1,
                colorID: carInfo?.ColorID,
                Type: 1,
                price: carInfo?.NetSalePrice,
                CartID: null,
                CostShipping: Shipping.Cost,
                VIN: carInfo?.SN,
                MiniDownPayment: carInfo?.MiniDownPayment ? carInfo?.MiniDownPayment : 5000,
              },
            ],
            //--------------
            parseInt(user_id),
            MiniDownPayment,
            paymentType,
            allServiceID,
            requestForm.address,
            InitializeOrder,
          );
        }
      } else {
        toast.error(trans("new:login_first"), {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      thisConfirmContext.onShowRegistrationPup(true);
    }
  };

  //PaymentMAin
  async function PaymentMAin(
    status,
    InfoLocation,
    InfoBranch,
    ByLocation,
    ByBranch,
    IsReservation,
    IsPayment,
    PaymentAmount,
    FinalTotal,
    AmountShipping,
    SubAmountTotal,
    TotalTaxAmount,
    TotalDiscount,
    Product,
    UserID,
    MiniDownPayment,
    MethodPayment,
    Accessories,
    Address,
    InitializeOrder,
  ) {
    handelSaveCachData();
    if (!isLoadingSendOrder) {
      //////console.log("handleSubmit:", requestForm);
      setLoadingSendOrder(true);

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const { ipv4 } = await getUserIpAddress();

      let listofServices;
      // allServiceID
      Accessories?.map((item) => {
        if (listofServices) listofServices += "," + item;
        else listofServices = item;
      });

      if (!MethodPayment && InitializeOrder) {
        MethodPayment = "Myfatoorah&SADAD";
      }
      var raw = {
        URL: `${window.location.origin}/${lang}/car/checkoutCash/${sn}/${slug}`,
        Lang: lang,
        Product: Product,
        Accessories: listofServices,
        NoteAccessories: noteAccessories,
        UserID: UserID,
        City: requestForm.City,
        DelivaryAddress: Address,
        NotificationWhatsApp: requestForm.NotificationWhatsApp == true ? 1 : 0,
        customerDetails: {
          IP: ipv4,
        },
        DataAmount: {
          FinalTotal: FinalTotal,
          AmountShipping: AmountShipping,
          SubAmountTotal: SubAmountTotal,
          TotalTaxAmount: TotalTaxAmount,
          TotalDiscount: TotalDiscount,
          MiniDownPayment: MiniDownPayment,
        },
        PaymentAmount: PaymentAmount,
        TypePaymnet: {
          IsReservation: isReservation,
          IsPayment: IsPayment,
          PaymnetTypeID: MethodPayment == "Financing" ? "Credit" : "Cash", //Credit - Cash
          MethodPayment: MethodPayment,
        },
        DeliveryType: {
          ByBranch: ByBranch,
          ByLocation: ByLocation,
        },
        DeliveryData: {
          InfoBranch: InfoBranch,
          InfoLocation: InfoLocation,
        },
        CobonData: {
          Code: couponDetail?.coupon?.code ?? null,
          ID: couponDetail?.coupon?.id ?? null,
          Amount: couponDetail?.coupon?.CAmount,
        },
        RefrancePayment: null,
        status: status,
        InitializeOrder: InitializeOrder,
        InitializeOrderID: dataInitializeOrder?.OrderId ? dataInitializeOrder?.OrderId : null,
        OrderDraftID: orderDraftID ? orderDraftID : null,
      };
      console.log("Payment", raw);
      // //test--------//
      // setDataInitializeOrder({
      //   OrderGUID: "847327E6-155F-49A7-ADC7-1C6C59D5635E",
      //   OrderId: "SO-2025-2225",
      // });

      // setCurrentStepIndex(1);

      // setTimeout(() => {
      //   handleFetchpdf("847327E6-155F-49A7-ADC7-1C6C59D5635E");
      // }, 1000);
      // setShowTimer(true);
      // return;
      // //test--------//
      axios
        .request({
          url: config.controllURL + "api/Payment/CarPayment",
          headers: myHeaders,
          data: raw,
          method: "POST",
          responseType: "json",
        })
        .then(function (response) {
          //// console.log('response1', response);

          var DataRow = response?.data;
          console.log(DataRow);
          let responseData = Array.isArray(DataRow) ? DataRow.find((p) => p.URL_Payment && p.OrderId) || DataRow[DataRow.length - 1] : DataRow;
          console.log("responseData", responseData);
          ////// console.log(response.data.URL_Payment);OrderId
          if (InitializeOrder === true) {
            setDataInitializeOrder(responseData);
            setCurrentStepIndex(1);
            setShowTimer(true);

            setTimeout(() => {
              handleFetchpdf(responseData?.OrderGUID);
            }, 1000);
          } else {
            //// console.log('responseData', responseData);
            var invoiceID = responseData?.SadadNumber;
            if (invoiceID) setSadadInfo(invoiceID);
            if (responseData?.URL_Payment) {
              window.location.href = responseData?.URL_Payment;
            } else if (responseData?.MessageError && responseData?.MessageError == "Duplicate Request") {
              window.location.href = `${window.location.origin}/${lang}/car/checkoutCash/${sn}/${slug}`;
            } else if (responseData?.OrderId && responseData?.ResponsMessage == "Paid") {
              setShowFinalPopupMessage(trans("new:paymentAlreadyMade"));
              setShowFinalPopup(true);
              setDataFinalPopup(responseData);
            } else if (responseData?.Message) {
              setShowFinalPopupMessage(responseData?.Message);
              setShowFinalPopup(true);
              setDataFinalPopup(responseData);
            } else {
              toast.error(trans("error:unknown_failure"));
            }
          }

          setLoadingSendOrder(false);
        })
        .then((response2) => {
          //// console.log('response2', response2);

          setLoadingSendOrder(false);
        })
        .catch((error) => {
          //// console.log('error', error.messages)

          // alert(error.messages)

          setLoadingSendOrder(false);
        });
    }
  }
  // to get info of current ipv4
  const getUserIpAddress = async () => {
    let currentIpv4Info = {};
    try {
      const response = await axios.get("https://geolocation-db.com/json/", { timeout: 1500 });
      if (response.status === 200) {
        const { IPv4, country_code, country_name } = response.data;
        currentIpv4Info.ipv4 = IPv4;
        currentIpv4Info.countryCode = country_code;
        currentIpv4Info.countryName = country_name;
      }
    } catch (error) {
      // toast.error(trans("extra:not_connection"))
      //// console.log(error);
    }
    return currentIpv4Info;
  };

  const handelSaveCachData = async () => {
    try {
      var cachData = {
        requestFormParm: requestForm,
        allServiceIDParm: allServiceID,
        allselectServicesParm: allselectServices,
        dataFullNumParm: dataFullNum,
        stepNumParm: stepNum,
        evaluationsParm: evaluations,
        isClientAccountParm: isClientAccount,
      };
      //// console.log("handelSaveCachData>>>>>>>>>>>>>>>>>>>>>>>>:", cachData);
      saveData(cachName, cachData, true);
    } catch (error) {}
  };

  const handelGetCachData = useCallback(() => {
    try {
      ////// console.log("handelGetCachData>>>>>>>>>>>>>>>>>>>>>>>>:", cachName);
      const cachdataobject = getData(cachName, true);
      ////// console.log("cachdataobject>>>>>>>>>>>>>>>>>>>>>>>>:", cachdataobject);
      const cachdata = JSON.parse(cachdataobject);
      ////// console.log("cachdata>>>>>>>>>>>>>>>>>>>>>>>>:", cachdata);
      const { requestFormParm, allServiceIDParm, allselectServicesParm, dataFullNumParm, stepNumParm, evaluationsParm, isClientAccountParm } = cachdata;
      //// console.log("cachdata>>>>>>>>>>requestFormParm>>>>>>>>>>>>>>:", requestFormParm);
      if (requestFormParm) {
        const val = { ...requestFormParm };
        val.OTP = null;
        val.verificationOTP = null;
        val.DateOfBirth = null;
        val.develviryType = null;
        val.develviryCity = null;
        val.develviryBranch = null;
        val.paymentType = "";
        handelSetRequestForm(val);
      }

      if (isClientAccountParm != null) setIsClientAccount(isClientAccountParm);

      if (allServiceIDParm) setAllServiceID(allServiceIDParm);

      if (allselectServicesParm) setAllSelectServices(allselectServicesParm);

      if (evaluationsParm) setEvaluations(evaluationsParm);
    } catch (error) {
      console.warn(error.messages);
    }
    handelSetPersonalData();
  }, [requestForm]);

  const handleTimerEnd = () => {
    setShowOTPCheckPopup(false);
    if (showFinalPopup !== true) {
      setShowFinalPopup(true);
      setShowFinalPopupMessage(trans("new:Payment_was_not_completed_Purchase_process_failed"));
      return;
    }
  };
  useEffect(() => {
    if (stepNum == 3) handleInitializeOrder();
  }, [stepNum]);
  const handleInitializeOrder = async () => {
    if (dataInitializeOrder == null || dataInitializeOrder?.OrderId == null) {
      setCurrentStepIndex(0);
      console.log("handleInitializeOrder:handlePayment");
      await handlePayment(true);
    } else if (pdfUrl == null) {
      handleFetchpdf(dataInitializeOrder?.OrderGUID);
    }
  };
  const [isSending, setIsSending] = useState(false);

  const SendAbsherOtp = async () => {
    if (isSending) return; // منع التكرار

    if (!requestForm.OTP) {
      setIsSending(true); // قفل الإرسال

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var identityNumber = requestForm?.identity;
      var raw = {
        identityNumber: identityNumber,
        lang: lang,
        custID: "التوثيق",
      };

      // //test--------------
      // //test- فقط في وضع الدفلوبر-------------
      // if (process.env.NODE_ENV === "development") {
      //   handleRunSubOTPCheckFunction("1235");
      //   setVerificationCode("1235");
      //   setIsSending(false);
      //   return;
      // }
      // //test--------------
      try {
        const response = await axios.request({
          url: "https://appw.hassanjameelapp.com/api/Payment/site_SendAbsherOtpOnly",
          headers: myHeaders,
          data: raw,
          method: "POST",
          responseType: "json",
        });

        const responseData = response?.data;
        let PersonalData = Array.isArray(responseData) ? responseData.find((p) => p.status == 1) : null;
        if (PersonalData) {
          setVerificationCode(PersonalData.verificationCode);
          handleRunSubOTPCheckFunction(PersonalData.verificationCode,identityNumber);
        } else {
          console.error("responseData:", responseData);
          toast.warn(trans("new:confirmation_code_error"));
        }
      } catch (error) {
        console.error("SendAbsherOtp error:", error);
      }

      setIsSending(false); // فتح القفل
      setLoadingYakeen(false);
    } else {
      const num = await checkStepsErrors();
      if (num >= stepNum) {
        if (stepNum <= 3) {
          setStepNum(stepNum + 1);
          handelSaveCachData();
        }
      }
    }
  };

  const YakeenGetSaudiData = async () => {
    var result = formValidate(schema_PersonalData, { ...requestForm }) ?? {};
    if (stepNum == 1) setError(result);

    // console.log("result:", result);

    if (Object.keys(result).length === 0) {
      if (!isLoadingYakeen) {
        setLoadingYakeen(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var identityNumber = requestForm?.identity; //"2545365146"
        var raw = {
          identityNumber: identityNumber,
          birthDateGo: moment(requestForm.DateOfBirth).format("YYYY-MM"),
          custID: null,
        };
        console.log("Payment", raw);

        axios
          .request({
            url: "https://appw.hassanjameelapp.com/api/Payment/YakeenGetPersonalData",
            headers: myHeaders,
            data: raw,
            method: "POST",
            responseType: "json",
          })
          .then(async function (response) {
            // console.log('YakeenGetPersonalData response:', response);

            const responseData = response?.data;
            let PersonalData = Array.isArray(responseData) && responseData.length == 1 ? responseData.find((p) => p.IdentityNo == identityNumber || p.YakeenUserType) : null;
            // console.log('PersonalData:', PersonalData);
            if (PersonalData) {
              const val = { ...requestForm };

              const address =
                lang === "ar"
                  ? [PersonalData?.BuildingNumber || "", PersonalData?.StreetAr || ""].filter(Boolean).join(" ") + // سطر 1: رقم المبنى والشارع
                    (PersonalData?.DistrictAr ? `، ${PersonalData.DistrictAr}` : "") + // سطر 1: الحي
                    "\n" +
                    [PersonalData?.CityAr || "", PersonalData?.PostCode || "", PersonalData?.AdditionalNumber ? `- ${PersonalData.AdditionalNumber}` : ""].filter(Boolean).join(" ") + // سطر 2: المدينة والرمز البريدي والرقم الإضافي
                    "\n" +
                    (PersonalData?.RegionNameAr || "") // سطر 3: المنطقة
                  : // English
                    [PersonalData?.BuildingNumber || "", PersonalData?.StreetEn || ""].filter(Boolean).join(" ") +
                    (PersonalData?.DistrictEn ? `, ${PersonalData.DistrictEn}` : "") +
                    "\n" +
                    [PersonalData?.CityEn || "", PersonalData?.PostCode || "", PersonalData?.AdditionalNumber ? `- ${PersonalData.AdditionalNumber}` : ""].filter(Boolean).join(" ") +
                    "\n" +
                    (PersonalData?.RegionNameEn || "");

              val.address = address;

              var CityCode = GetCityCodeByYagenCityName(PersonalData?.CityEn);
              const name =
                lang === "ar"
                  ? [PersonalData?.FirstNameAr ?? "", PersonalData?.FatherNameAr ?? "", PersonalData?.GrandFatherNameAr ?? "", PersonalData?.FamilyNameAr ?? ""].filter(Boolean).join(" ")
                  : [PersonalData?.FirstNameEn ?? "", PersonalData?.FatherNameEn ?? "", PersonalData?.GrandFatherNameEn ?? "", PersonalData?.FamilyNameEn ?? ""].filter(Boolean).join(" ");

              val.name = name;
              val.City = CityCode;
              val.develviryCity = CityCode;
              setValueCitie(CityCode);
              handelSetRequestForm(val);

              const num = await checkStepsErrors(val);

              if (num >= stepNum) {
                if (stepNum < 3) {
                  setStepNum(stepNum + 1);
                }
              } else {
                // checkErrors();
              }
            } else {
              console.error("responseData:", responseData);
              //alert("البيانات:\n" + JSON.stringify(raw, null, 2));
              //alert("النتائج:\n" + JSON.stringify(responseData, null, 2));
              toast.warn(trans("new:invalid_data"));
            }

            setLoadingYakeen(false);
          })
          .catch((error) => {
            // console.log('error', error.messages)
            setLoadingYakeen(false);
          });
      }
    }
    // setLoadingYakeen(false);
  };

  const handleConfirmationAgreementViewer = (code) => {};

  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [stepsInfo, setStepsInfo] = useState([
    { title: trans("new:create_order"), description: "" },
    { title: trans("new:reserve_car"), description: "" },
    { title: trans("new:create_sales_contract"), description: "" },
  ]);
  const [percent, setPercent] = useState(0);

  const [pdfUrl, setPdfUrl] = useState(null);
  const handleFetchpdf = (OrderGUID) => {
    const fetchPdf = async () => {
      //   var pdfUrlFull =  `https://cloud.hassanjameel.com.sa/tools/webreports?ObjectName=MInvoiceOnline&GUID=${OrderGUID}&ReportID=329B1875-3DB2-4AC5-B8ED-3A9D2B511D11&type=OnlineRegistration`;
      const reportBaseUrl =
        config.reportUrl || `https://cloud.hassanjameel.com.sa/tools/webreports?ObjectName=MInvoiceOnline&GUID=&ReportID=329B1875-3DB2-4AC5-B8ED-3A9D2B511D11&type=OnlineRegistration`;
      const url = new URL(reportBaseUrl);
      url.searchParams.set("GUID", OrderGUID);
      var pdfUrlFull = url.toString();

      setCurrentStepIndex(2);
      try {
        const response = await axios.post(
          config.controllURL + "api/Payment/load-payment-agreemnt",
          { url: pdfUrlFull },
          {
            headers: { "Content-Type": "application/json" },
          },
        );
        const base64String = response.data;
        const blob = base64ToBlob(base64String, "application/pdf");
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
        setCurrentStepIndex(3);
      } catch (error) {
        console.error("PDF load failed:", error);
        setPdfUrl(pdfUrlFull);
        setCurrentStepIndex(3);
      } finally {
      }
    };

    fetchPdf();

    // تنظيف URL عند انتهاء العرض
    return () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
  };

  const base64ToBlob = (base64, mime) => {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length).fill(0).map((_, i) => byteChars.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
  };

  return (
    <>
      <section className="carOverview-page custom-ant  nice-relative carCheckout-page flex flex-col ">
        <div className="nice-sticky-z-index show-xs" style={{ zIndex: 9 }}>
          <div className="flex flex-col  nice-align-item-center   nice-shadow-1 bg-white w-100">
            <div className=" flex flex-row justify-between nice-align-item-center py-10 px-10   w-100 ">
              <img
                className=" rotate-180"
                src="/assets/icons/arrow-right.svg"
                width="7"
                height="7"
                alt="arrow"
                onClick={() => {
                  history.goBack();
                }}
              />
              <span className="text-30">{trans("info:Cash_Car_Purchase")} </span>
              {!orderDraftID && (
                <span
                  className=" text-24 text-gray"
                  onClick={() => {
                    sn &&
                      slug &&
                      history.push({
                        pathname: `/car/overview/${sn}/${slug}`,
                        search: "",
                      });
                  }}>
                  {trans("new:cancel")}{" "}
                </span>
              )}
            </div>

            <div className="nice-shadow-2 bg-white w-100">
              <div className=" py-2 px-5 ">
                {/* <div className="py-5 flex flex-row justify-between nice-align-item-center">
                                    <h3 className="text-30 text-bold ">{"تفاصيل الطلب"}</h3>

                                    
                                </div> */}

                <div className="ruler-2 mb-5"></div>

                {showFinalPopup !== true && showTimer === true && (
                  <div className="flex flex-col justify-center">
                    <h4 className="text-40 text-bold text-center text-error ">
                      {" "}
                      <CounterOnEnd seconds={600} onEnd={() => {}} />
                    </h4>
                  </div>
                )}

                <div className="carOverview-page-body flex flex-row justify-between nice-align-item-center">
                  {propsData?.vehicle ? (
                    <>
                      <div className="carOverview-page-body-desc">
                        <div className="carOverview-page-body-name">
                          <div className="carOverview-page-body-type ">
                            <div className="carOverview-page-body-type-content nice-gap-1rem">
                              <h2 className="text-20 text-bold">{propsData?.vehicle?.brand && propsData?.vehicle?.brand}</h2>
                              {/* <img src={vehicle?.brandIconPath && vehicle?.brandIconPath} /> */}
                              <img className="" alt="" src={`/assets/icons/brands/${(isToyota ? "toyota" : "") + (isLexus ? "lexus" : "")}.webp`} />
                            </div>
                          </div>

                          <h3 className="text-20 text-gray ">{activeModel?.modelDescription && activeModel?.modelDescription}</h3>
                          {carInfo ? (
                            <h3 className={"text-20 text-gray"}>
                              {carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[0] +
                                " / " +
                                carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[1]}
                            </h3>
                          ) : null}
                        </div>
                      </div>

                      <div
                        className="carOverview-page-body-img"
                        style={{
                          maxWidth: "70%",
                        }}>
                        {filterCarImages && filterCarImages[0] && <img className="carOverview-page-header-img" src={config.FilePathURL + filterCarImages[0]?.Image_URL} alt="" />}
                      </div>
                    </>
                  ) : (
                    <div className="container search-line my-40">
                      <h4 className="text-gray text-20 py-2">{trans("new:no_data")}</h4>
                    </div>
                  )}
                </div>
                <div className="ruler-2 mb-5"></div>
                <div className="nice-container flex flex-col gap-3 justify-between">
                  <div className="flex flex-col justify-center">
                    {
                      <>
                        <div className="nice-flex nice-flex-row nice-flex-space-between mb-10">
                          <h4 className="text-20">
                            {trans("new:cash_price")}&nbsp;<span className="text-20 text-gray mx-1">{trans("new:price_inclusive_note")}</span>{" "}
                          </h4>
                          <span className="text-20 font-bold text-primary">{carInfo?.NetSalePrice && <Price price={parseFloat(carInfo?.NetSalePrice)} />}</span>
                        </div>
                        {allselectServices && allselectServices.length > 0 && (
                          <div className="nice-flex nice-flex-row nice-flex-space-between mb-10">
                            <h4 className="text-20">
                              {trans("new:accessories")}&nbsp;<span className="text-20 text-gray mx-1">{trans("new:Incloding_VAT")}</span>{" "}
                            </h4>

                            <div dir="ltr" className={"flex text-20 text-error font-bold"}>
                              {" "}
                              {allselectServices?.reduce((total, service) => total + service.Price, 0) ? (
                                <>
                                  {" "}
                                  <Price price={allselectServices?.reduce((total, service) => total + service.Price, 0)} className={"white-space-pre"} />
                                  {" + "}{" "}
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}

                        {SubTotal && (
                          <div className="cart-grid-info-div">
                            <div className={"text-20 text-gray"}>{trans("cartFile:Downpayment")}</div>
                            <div className={"text-20 text-gray font-bold"}>{numberFormat(SubTotal, lang)}</div>
                          </div>
                        )}
                        {develviryType == 1 && (
                          <>
                            {Shipping.CountTime ? (
                              <div className="cart-grid-info-div ">
                                <div className={"text-20 text-gray "}>
                                  {trans("cartFile:receive_peroid")} {" (" + trans("cartFile:After_issuing_the_plates") + ") "}
                                </div>
                                <div className={"text-20 text-gray font-bold"}>
                                  {Shipping.CountTime} <span className={"text-20 text-gray font-bold"}>{trans("cartFile:" + (Shipping.UnitTime ?? ""))}</span>{" "}
                                </div>
                              </div>
                            ) : null}
                            {Shipping.CostWithTax ? (
                              <div className="cart-grid-info-div">
                                <div className={"text-20 text-gray"}>{trans("cartFile:shipping_costs")}</div>
                                <div className={"text-20 text-gray font-bold"}>{numberFormat(Shipping.CostWithTax, lang)}</div>
                              </div>
                            ) : null}
                          </>
                        )}
                      </>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="checkoutStepper nice-shadow-2 bg-white w-100 pt-10">
              <div
                className={"checkoutStepper-part " + (dataFullNum > 0 ? "active" : " ")}
                // onClick={() => cheangeSteps(1)}
              >
                <div className={`checkoutStepper-part-titel ${stepNum == 1 ? " active" : null}`}>
                  <span>{trans("new:verify_identity")}</span>
                </div>
                <div className={"checkoutStepper-part-connector  "}></div>
              </div>
              <div
                className={"checkoutStepper-part " + (dataFullNum > 1 ? "active" : " ")}
                // onClick={() => cheangeSteps(2)}
              >
                <div className={`checkoutStepper-part-titel ${stepNum == 2 ? " active" : null}`}>
                  <span>{trans("new:shipping")}</span>
                </div>
                <div className={"checkoutStepper-part-connector  "}></div>
              </div>
              <div
                className={"checkoutStepper-part " + (dataFullNum > 2 ? "active" : " ")}
                // onClick={() => cheangeSteps(3)}
              >
                <div className={`checkoutStepper-part-titel ${stepNum == 3 ? " active" : null}`}>
                  <span> {trans("new:digital_signature")}</span>
                </div>
                <div className={"checkoutStepper-part-connector  "}></div>
              </div>

              <div
                className={"checkoutStepper-part " + (dataFullNum > 3 ? "active" : " ")}
                // onClick={() => cheangeSteps(4)}
              >
                <div className={`checkoutStepper-part-titel ${stepNum == 4 ? " active " : null}`}>
                  <span>{orderDraftID ? trans("new:complete_order") : trans("new:payment_options")}</span>
                </div>
                <div className={"checkoutStepper-part-connector  "}></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="carOverview-page-content grid grid-cols-12 gap-3
                          justify-items-auto mx-30 mt-10">
          <div className="carOverview-page-main  h-vh border-radius col-span-12 md:col-span-8 sm:col-span-8 lg:col-span-9 xl:col-span-9">
            <div className="flex mb-5 hide-xs">
              {!orderDraftID && (
                <div
                  className={"btn nice-flex-row border-radius nice-shadow-1 nice-border-checkout-gray  bg-white px-10  py-5  text-24 "}
                  onClick={() => {
                    sn &&
                      slug &&
                      history.push({
                        pathname: `/car/overview/${sn}/${slug}`,
                        search: "",
                      });
                  }}>
                  {trans("new:cancel")}{" "}
                </div>
              )}
            </div>

            <div className=" px-20 carOverview-page-main nice-shadow-3 bg-white  h-vh border-radius col-span-12">
              <div className="flex flex-col py-20  px-10 ">
                <div className="checkoutStepper hide-xs">
                  <div
                    className={"checkoutStepper-part " + (dataFullNum > 0 ? "active" : " ")}
                    // onClick={() => cheangeSteps(1)}
                  >
                    <div className={`checkoutStepper-part-titel ${stepNum == 1 ? " active" : null}`}>
                      <span>{trans("new:verify_identity")}</span>
                    </div>
                    <div className={"checkoutStepper-part-connector  "}></div>
                  </div>
                  <div
                    className={"checkoutStepper-part " + (dataFullNum > 1 ? "active" : " ")}
                    // onClick={() => cheangeSteps(2)}
                  >
                    <div className={`checkoutStepper-part-titel ${stepNum == 2 ? " active" : null}`}>
                      <span>{trans("new:shipping")}</span>
                    </div>
                    <div className={"checkoutStepper-part-connector  "}></div>
                  </div>
                  <div
                    className={"checkoutStepper-part " + (dataFullNum > 2 ? "active" : " ")}
                    // onClick={() => cheangeSteps(3)}
                  >
                    <div className={`checkoutStepper-part-titel ${stepNum == 3 ? " active" : null}`}>
                      <span> {trans("new:digital_signature")}</span>
                    </div>
                    <div className={"checkoutStepper-part-connector  "}></div>
                  </div>

                  <div
                    className={"checkoutStepper-part " + (dataFullNum > 3 ? "active" : " ")}
                    // onClick={() => cheangeSteps(4)}
                  >
                    <div className={`checkoutStepper-part-titel ${stepNum == 4 ? " active " : null}`}>
                      <span>{orderDraftID ? trans("new:complete_order") : trans("new:payment_options")}</span>
                    </div>
                    <div className={"checkoutStepper-part-connector  "}></div>
                  </div>
                </div>

                <form
                  className="flex flex-col  my-5 "
                  onSubmit={(e) => {
                    // submitRequest(e);
                  }}>
                  {stepNum == 1 && (
                    <>
                      {/* <h3 className="text-30 text-bold mb-10  ">{trans("new:addYourInformation")}</h3> */}

                      <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-20 ">
                        {
                          <>
                            <InputField
                              key={"identity"}
                              length={10}
                              // disabled={personalDataRequest?.identity}
                              moduleLabel={trans("form:identity-no")}
                              name="identity"
                              errorLabel={error?.identity}
                              extraClasses={"Input-module"}
                              value={requestForm?.identity}
                              onChangeValue={(e) => {
                                const val = { ...requestForm };
                                val.identity = e.target.value;
                                setRequestForm(val);
                              }}
                              placeholder={trans("form:identity-no")}
                            />
                          </>
                        }
                      </div>

                      <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-20 w-100">
                        {/* <DatePicker
                                                    showIcon
                                                    isClearable={!!requestForm.DateOfBirth}

                                                    className=" w-100"
                                                    selected={requestForm.DateOfBirth ? new Date(requestForm.DateOfBirth) : null}
                                                    onChange={async (value) => {


                                                        // console.log("NNNNNNNNNNNNNN:>>>>", value)

                                                        const val = { ...requestForm };
                                                        val.DateOfBirth = value;
                                                        setRequestForm(val);


                                                    }}


                                                    placeholderText={trans("form:date-of-birth")}

                                                    dateFormat="yyyy/MM"
                                                    // showMonthYearPicker
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    // dropdownMode="select"
                                                    minDate={new Date(1960, 0)} // من يناير 1990
                                                    maxDate={new Date(2020, 12)}        // حتى اليوم
                                                    showFullMonthYearPicker     // عرض كل الشهور مع السنوات
                                                    yearItemNumber={100}
                                                    yearDropdownItemNumber={100}
                                                    scrollableYearDropdown
                                                    openToDate={requestForm.DateOfBirth ? requestForm.DateOfBirth : new Date("1993/09/28")}

                                                    // withPortal
                                                    // inline
                                                    customInput={<DateInput3
                                                        errorLabel={error?.DateOfBirth}
                                                        value={moment(requestForm.DateOfBirth).format('yyyy/MM')}
                                                    />}
                                                /> */}
                        <Space direction="vertical" style={{ width: "100%" }}>
                          <DatePicker
                            style={{ width: "100%" }}
                            status={error?.DateOfBirth ? "error" : ""}
                            size={"large"}
                            placeholder={trans("form:date-of-birth")}
                            defaultValue={dayjs("1985/09", "YYYY/MM")}
                            value={requestForm.DateOfBirth ? dayjs(moment(requestForm.DateOfBirth).format("YYYY/MM"), "YYYY/MM") : null}
                            // pickerValue={requestForm.DateOfBirth ? dayjs(moment(requestForm.DateOfBirth).format('YYYY/MM')) : dayjs('1999/09', 'YYYY/MM')}
                            defaultPickerValue={requestForm.DateOfBirth ? dayjs(moment(requestForm.DateOfBirth).format("YYYY/MM")) : dayjs("1985/09", "YYYY/MM")}
                            onChange={async (value) => {
                              console.log("DatePicker:>>>>", value);
                              try {
                                var date = value ? dayjs(value, "YYYY/MM") : null;
                                /*  console.log("DatePicker:>>>>", date)*/

                                const val = { ...requestForm };
                                if (date.isValid()) {
                                  val.DateOfBirth = date.toDate(); // تحويل صحيح إلى كائن Date
                                  //console.log("toDate: DateOfBirth1111>>>>", val.DateOfBirth);
                                  //console.log("toDate: DateOfBirth11111>>>>", moment(val.DateOfBirth).format('YYYY-MM'));
                                } else {
                                  console.error("Invalid date:", value);
                                }
                                setRequestForm(val);
                              } catch {
                                console.log("DatePicker error:>>>>", date);
                                const val = { ...requestForm };
                                val.DateOfBirth = null;
                                setRequestForm(val);
                              }
                            }}
                            picker="month"
                          />
                        </Space>
                      </div>
                      <div className="mt-20 flex flex-row border-box-periodic-checkInput col-span-12 md:col-span-8 sm:col-span-8 lg:col-span-8 xl:col-span-8">
                        <CheckInput
                          className="text-primary cursor-pointer"
                          checked={checkoutAgreemnt}
                          errorLabel={error.checkoutAgreemnt}
                          oncheng={async (target) => {
                            setChecAgreemnt(!checkoutAgreemnt);

                            const val = { ...requestForm };
                            val.checkoutAgreemnt = !checkoutAgreemnt;
                            setRequestForm(val);
                          }}
                          Name={"check-agremnt"}>
                          <span className="text-20 nice-pointer text-inline-block">{trans("new:terms_conditions")}</span>
                        </CheckInput>
                        <a href={`/${lang}/websitePolicy`} target="_blank" className="text-20 nice-pointer mx-5 text-info text-inline-block">
                          {trans("new:website_policy")}
                        </a>
                      </div>
                      <div className="ruler-2 mt-20 mb-5"></div>

                      <p className="text-20 text-gray text-bold text-inline-block mt-20">{trans("new:account_verification_note")}</p>

                      <div className=" grid nice-align-item-center grid-cols-12 gap-5 justify-items-auto p-10   my-20 ">
                        <div className="border-box-periodic-checkInput col-span-12 md:col-span-7 sm:col-span-7 lg:col-span-7 xl:col-span-7"></div>

                        <div className="col-span-12 md:col-span-5 sm:col-span-5 lg:col-span-5 xl:col-span-5">
                          <div
                            className={"btn nice-flex-row  py-5 px-5 text-white text-24 " + (checkoutAgreemnt && requestForm?.identity && requestForm.DateOfBirth ? " bg-primary " : " bg-gray ")}
                            onClick={async () => {
                              console.log("requestForm:", requestForm);
                              console.log("checkoutAgreemnt:", checkoutAgreemnt);
                              if (checkoutAgreemnt && requestForm?.identity && requestForm.DateOfBirth) {
                                console.log("YakeenGetSaudiData:");
                                SendAbsherTPCheckYakeenData();
                              }
                            }}>
                            {trans("new:verification")}
                            {isLoadingYakeen && (
                              <span className="mx-2 loading-btn ">
                                <img className="object-max-full " alt="" src="/assets/icons/loading.svg" width="25" height="25" />
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {stepNum == 2 && (
                    <>
                      {/* <h3 className="text-30 text-bold mb-10  ">{" الشحن "}</h3> */}

                      <div className="mainteance-popup-container-header py-5 flex flex-col ">
                        <p className="protection-and-shading-titel-sub1 text-20 text-bold ">
                          {(lang == "ar" ? "حياك الله" : "Welcome") + (requestForm?.name?.split(" ")[0] ? (lang == "ar" ? " يا" : ",") + requestForm.name.split(" ")[0] : " ") + " "}
                        </p>
                        <p className="protection-and-shading-titel-sub2 text-20 text-bold text-gray">
                          {lang == "ar" ? "كل اللي عليك الحين تختار كيف تبي تستلم سيارتك!" : "All you need to do now is choose how you'd like to receive your car."}
                        </p>
                      </div>

                      <SectionHeading hasRuler={false} title={trans("extra:choose_receive_way") + ":"}>
                        <RadioInputDynamic
                          onChangeValue={(value) => {
                            const cunrrentvalue = currentDeliveryMethod;
                            setDeleviryType(value);
                            cunrrentvalue.branchMethod = value === 2 ? true : false;
                            cunrrentvalue.locationMethod = value === 1 ? true : false;
                            setcurrentDeliveryMethod(cunrrentvalue);

                            const val = { ...requestForm };
                            val.develviryType = value;
                            setRequestForm(val);
                          }}
                          extraClasses={"Radio-Input-module"}
                          selectValue={develviryType}
                          name="recieveMethod"
                          groupName="recieveMethod"
                          title={""}
                          ListValues={[
                            { text: trans("new:delivery"), value: 1 },
                            {
                              text: trans("new:branch"),
                              value: 2,
                            },
                          ]}
                          errorLabel={error.develviryType}
                        />
                        {
                          <>
                            {develviryType == 2 && (
                              <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-20 ">
                                <DropDownInput
                                  title={trans("cartFile:branch")}
                                  onSelect={(option) => {}}
                                  extraClasses={"dropdown-Input-module"}
                                  selectedValue={requestForm?.develviryBranch}
                                  options={[
                                    ...Branches.map((A) => {
                                      if (lang === "ar") {
                                        return { value: A.SiteID, text: A.DescriptionAr };
                                      } else {
                                        return { value: A.SiteID, text: A.DescriptionEn };
                                      }
                                    }),
                                  ]}
                                  onfilter={getValueBranch}
                                />

                                <BranchesInfo values={branchesDetails} />
                              </div>
                            )}
                            {develviryType == 1 && (
                              <>
                                <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-20 ">
                                  <DropDownInput
                                    extraClasses={"dropdown-Input-module"}
                                    title={trans("new:city")}
                                    selectedValue={requestForm?.develviryCity}
                                    options={[...cities]}
                                    onfilter={(Citey) => CarShippingInfo(Citey, Size)}
                                  />

                                  <p className="text-20 text-gray text-inline-block">{trans("new:car_shipping_costs_added_to_total_amount")}</p>
                                </div>

                                <div className="flex flex-row grid-1-cols-importent nice-gap-2rem mt-20 ">
                                  <TextArea
                                    row={4}
                                    placeholder={""}
                                    disabled={personalDataRequest?.address}
                                    moduleLabel={trans("new:address")}
                                    value={requestForm.address}
                                    errorLabel={error.address}
                                    extraClasses={"Textarea-module"}
                                    onChangeValue={(e) => {
                                      const val = { ...requestForm };
                                      val.address = e;
                                      setRequestForm(val);
                                    }}
                                    name="address"
                                  />
                                </div>
                              </>
                            )}
                          </>
                        }
                      </SectionHeading>

                      <div className=" grid nice-align-item-center grid-cols-12 gap-5 justify-items-auto p-10   my-20 ">
                        <div className="border-box-periodic-checkInput col-span-12 md:col-span-6 sm:col-span-6 lg:col-span-6 xl:col-span-6"></div>

                        <div className="col-span-12 md:col-span-6 sm:col-span-6 lg:col-span-6 xl:col-span-6">
                          <div
                            className={"btn nice-flex-row  py-5 px-5 text-white text-24 " + (dataFullNum > 1 ? " bg-primary " : " bg-gray ")}
                            onClick={async () => {
                              const num = await checkStepsErrors();

                              if (num >= stepNum) {
                                if (stepNum <= 3) {
                                  setStepNum(stepNum + 1);
                                }
                              } else {
                                // checkErrors();
                              }
                            }}>
                            {trans("new:go_to_e_signature")}
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {stepNum == 3 &&
                    (dataInitializeOrder != null && pdfUrl != null ? (
                      <>
                        <h3 className="text-20 text-bold mt-2 mb-10  ">{trans("new:sign_sales_contract")}</h3>

                        <AgreementViewer pdfUrl={pdfUrl} onConfirm={handleConfirmationAgreementViewer} />

                        <div className="mt-20 flex flex-row border-box-periodic-checkInput col-span-12 md:col-span-8 sm:col-span-8 lg:col-span-8 xl:col-span-8">
                          <CheckInput
                            className="text-primary cursor-pointer"
                            checked={checkoutAbsherOtp}
                            errorLabel={error.checkoutAbsherOtp}
                            oncheng={async (target) => {
                              if (!requestForm.OTP) {
                                setCheckoutAbsherOtp(!checkoutAbsherOtp);

                                const val = { ...requestForm };
                                val.checkoutAbsherOtp = !checkoutAbsherOtp;
                                setRequestForm(val);
                              }
                            }}
                            Name={"check-agremnt"}>
                            <span className="text-20 nice-pointer text-inline-block">{trans("new:agree_to_terms")}</span>
                          </CheckInput>
                        </div>
                        <div className=" grid nice-align-item-center grid-cols-12 gap-5 justify-items-auto p-10   my-20 ">
                          <div className="border-box-periodic-checkInput col-span-12 md:col-span-7 sm:col-span-7 lg:col-span-7 xl:col-span-7"></div>

                          <div className="col-span-12 md:col-span-5 sm:col-span-5 lg:col-span-5 xl:col-span-5">
                            <div
                              className={"btn nice-flex-row  py-5 px-5 text-white text-24 " + (dataFullNum > 1 && checkoutAbsherOtp ? " bg-primary " : " bg-gray ")}
                              onClick={async () => {
                                if (requestForm.checkoutAbsherOtp == true) SendAbsherOtp();
                              }}>
                              {!requestForm.OTP ? trans("new:confirm_and_continue") : trans("new:continue")}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <StepProgressBar stepsInfo={stepsInfo} currentStepIndex={currentStepIndex} percent={percent} desc={trans("new:do_not_close_browser")} />
                      </>
                    ))}

                  {stepNum == 4 && (
                    <>
                      <>
                        <div className="ruler-2 mt-20 mb-5"></div>

                        {
                          <div className="cart-grid-info-div ">
                            <div className={"text-20 font-bold text-black"}>
                              {activeModel?.modelDescription} {activeModel?.year}
                              &nbsp;<span className="text-20 text-gray mx-1">{trans("new:price_inclusive_note")}</span>
                            </div>
                            <div className={"text-20 text-black nice-space-nowrap text-primary font-bold"}>{numberFormat(fullTotal, lang)}</div>
                          </div>
                        }
                        {carInfo ? (
                          <div className="cart-grid-info-div ">
                            <div className={"text-20 text-gray"}>{trans("new:exterior_color") + " : " + carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[0]}</div>
                            <div className={"text-20 text-gray font-bold"}>{numberFormat(0, lang)}</div>
                          </div>
                        ) : null}
                        {carInfo ? (
                          <div className="cart-grid-info-div border-t">
                            <div className={"text-20 text-gray"}>{trans("new:interior_color") + ": " + carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[1]}</div>
                            <div className={"text-20 text-gray font-bold"}>{numberFormat(0, lang)}</div>
                          </div>
                        ) : null}
                        {develviryType == 1 && (
                          <>
                            {Shipping.CountTime ? (
                              <div className="cart-grid-info-div ">
                                <div className={"text-20 text-gray "}>{trans("cartFile:receive_peroid")}</div>
                                <div className={"text-20 text-gray font-bold"}>
                                  {Shipping.CountTime} <span className={"text-20 text-gray font-bold"}>{trans("cartFile:" + (Shipping.UnitTime ?? ""))}</span>{" "}
                                </div>
                              </div>
                            ) : null}
                            {Shipping.CostWithTax ? (
                              <div className="cart-grid-info-div">
                                <div className={"text-20 text-gray"}>{trans("cartFile:shipping_costs")}</div>
                                <div className={"text-20 text-gray font-bold"}>{numberFormat(Shipping.CostWithTax, lang)}</div>
                              </div>
                            ) : null}
                          </>
                        )}

                        {TotalDiscount ? (
                          <div className="cart-grid-info-div ">
                            <div className={"text-20 text-gray"}>{trans("cartFile:discount_total")}</div>
                            <div className={"text-20 text-gray font-bold"}>{numberFormat(TotalDiscount, lang)}</div>
                          </div>
                        ) : null}

                        {allselectServices && allselectServices.length > 0 ? (
                          <div className="cart-grid-info-div ">
                            <div className={"text-20 font-bold text-black"}>
                              {trans("new:Total_Accessories")}&nbsp;<span className="text-20 text-gray mx-1">{trans("new:Incloding_VAT")}</span>
                            </div>
                            <div dir="ltr" className={"flex text-20 text-error font-bold"}>
                              {" "}
                              {allselectServices?.reduce((total, service) => total + service.Price, 0) ? (
                                <>
                                  {" "}
                                  <Price price={allselectServices?.reduce((total, service) => total + service.Price, 0)} className={"white-space-pre"} /> {" + "}{" "}
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        ) : null}

                        {develviryType == 1 ? (
                          <>
                            <div className="cart-grid-info-div border-tb">
                              <div className={"text-20 font-bold text-black"}>{trans("cart:total")}</div>
                              <div className={"text-20 text-black font-bold"}>
                                {numberFormat(allselectServices?.reduce((total, service) => total + service.Price, 0) + fullTotal + Shipping.CostWithTax - TotalDiscount, lang)}
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="cart-grid-info-div border-tb">
                            <div className={"text-20 font-bold text-black"}>{trans("cart:total")}</div>
                            <div className={"text-20 text-black font-bold"}>
                              {numberFormat(allselectServices?.reduce((total, service) => total + service.Price, 0) + fullTotal - TotalDiscount, lang)}
                            </div>
                          </div>
                        )}

                        {SubTotal && (
                          <div className="cart-grid-info-div">
                            <div className={"text-20 text-gray"}>{trans("cartFile:Downpayment")}</div>
                            <div className={"text-20 text-gray font-bold"}>{numberFormat(SubTotal, lang)}</div>
                          </div>
                        )}

                        {orderDraftID && SubTotal && (
                          <div className="cart-grid-info-div">
                            <div className={"text-20 text-gray"}>{trans("new:paid_amount")}</div>
                            <div className={"text-20 text-gray font-bold"}>{numberFormat(SubTotal, lang)}</div>
                          </div>
                        )}

                        {orderDraftID ? (
                          develviryType == 1 ? (
                            <>
                              <div className="cart-grid-info-div border-tb">
                                <div className={"text-20 font-bold text-black"}>{trans("new:remaining_amount")}</div>
                                <div className={"text-20 text-black font-bold"}>
                                  {numberFormat(allselectServices?.reduce((total, service) => total + service.Price, 0) + fullTotal + Shipping.CostWithTax - TotalDiscount - SubTotal, lang)}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="cart-grid-info-div border-tb">
                              <div className={"text-20 font-bold text-black"}>{trans("new:remaining_amount")}</div>
                              <div className={"text-20 text-black font-bold"}>
                                {numberFormat(allselectServices?.reduce((total, service) => total + service.Price, 0) + fullTotal - TotalDiscount - SubTotal, lang)}
                              </div>
                            </div>
                          )
                        ) : (
                          <div className="cart-grid-info-div border-tb">
                            <div className={"text-20 font-bold text-black"}>{trans("new:min_down_payment")}</div>
                            <div className={"text-20 text-black font-bold"}>{numberFormat(MiniDownPayment, lang)}</div>
                          </div>
                        )}
                      </>

                      {
                        <div className="my-10 ">
                          <div className="flex flex-col  nice-gap-2rem">
                            <h3 className="text-gray text-20">{trans("new:avilable_platforms")}</h3>

                            {isReservation == true ? (
                              <div className="breakout!! flex flex-col nice-gap-2rem ">
                                {platformTypes && platformTypes.includes("payTabs") && (
                                  <div
                                    className={"flex flex-col nice-pointer  nice-gap-2rem   " + (paymentType == "PayTabs&SADAD" ? " bg-gray-lighter " : "")}
                                    onClick={() => {
                                      setPaymentType("Myfatoorah&SADAD");
                                      const val = { ...requestForm };
                                      val.paymentType = "Myfatoorah&SADAD";
                                      setRequestForm(val);
                                    }}>
                                    <label className={" text-20 font-bold flex flex-row nice-gap-1rem "}>
                                      <input type="radio" checked={paymentType == "PayTabs&SADAD" ? true : false} name="paymentType" id="primary" />
                                      {trans("new:sadad")}
                                    </label>
                                    <div className="flex flex-row items-center  mx-10">
                                      <img className=" object-contain" width={50} height={50} src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />
                                    </div>
                                  </div>
                                )}

                                {platformTypes && platformTypes.includes("myfatoorah") && (
                                  <div
                                    className={"flex flex-col nice-pointer nice-gap-2rem border-radius p-5 " + (paymentType == "Myfatoorah&SADAD" ? " bg-gray-light " : "")}
                                    onClick={() => {
                                      setPaymentType("Myfatoorah&SADAD");
                                      const val = { ...requestForm };
                                      val.paymentType = "Myfatoorah&SADAD";
                                      setRequestForm(val);
                                    }}>
                                    <label className={" nice-pointer text-20 font-bold flex flex-row nice-gap-1rem "}>
                                      <input type="radio" checked={paymentType == "Myfatoorah&SADAD" ? true : false} name="paymentType" id="primary" />
                                      {trans("new:sadad")}
                                    </label>
                                    <div className="flex nice-pointer flex-row items-center  mx-10">
                                      <img className=" object-contain" width={50} height={50} src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />
                                    </div>
                                  </div>
                                )}

                                <div
                                  className={"flex flex-col nice-pointer  nice-gap-2rem border-radius py-10 p-5 " + (paymentType == "Myfatoorah&Branch" ? " bg-gray-light " : "")}
                                  onClick={() => {
                                    setPaymentType("Myfatoorah&Branch");
                                    const val = { ...requestForm };
                                    val.paymentType = "Myfatoorah&Branch";
                                    setRequestForm(val);
                                  }}>
                                  <label className={"nice-pointer text-20 font-bold flex flex-row nice-gap-1rem "}>
                                    <input type="radio" checked={paymentType == "Myfatoorah&Branch" ? true : false} name="paymentType" id="primary" />
                                    {trans("new:by_branch")}
                                  </label>
                                </div>
                              </div>
                            ) : (
                              <div className="breakout!! flex flex-col nice-gap-2rem ">
                                {platformTypes && platformTypes.includes("payTabs") && (
                                  <div
                                    className={"flex flex-col nice-pointer  nice-gap-2rem   " + (paymentType == "PayTabs&SADAD" ? " bg-gray-lighter " : "")}
                                    onClick={() => {
                                      setPaymentType("Myfatoorah&SADAD");
                                      const val = { ...requestForm };
                                      val.paymentType = "Myfatoorah&SADAD";
                                      setRequestForm(val);
                                    }}>
                                    <label className={" text-20 font-bold flex flex-row nice-gap-1rem "}>
                                      <input type="radio" checked={paymentType == "PayTabs&SADAD" ? true : false} name="paymentType" id="primary" />
                                      {trans("new:online_batch") + " " + trans("new:and_the_rest_via_SADAD")}
                                    </label>
                                    <div className="flex flex-row items-center  mx-10">
                                      <img className="cart-payment-icon object-contain" src="/assets/icons/companies/master-card-3.png" alt={"master"} />
                                      <img className="cart-payment-icon object-contain" src="/assets/icons/companies/visa-3.png" alt={"visa"} />
                                      <img className="cart-payment-icon object-contain" src="/assets/icons/companies/mada-3.png" alt={"mada"} />

                                      <img className="cart-payment-icon object-contain" src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />
                                    </div>
                                  </div>
                                )}

                                {platformTypes && platformTypes.includes("myfatoorah") && (
                                  <div
                                    className={"flex flex-col nice-pointer  nice-gap-2rem border-radius p-5 " + (paymentType == "Myfatoorah&SADAD" ? " bg-gray-light " : "")}
                                    onClick={() => {
                                      setPaymentType("Myfatoorah&SADAD");
                                      const val = { ...requestForm };
                                      val.paymentType = "Myfatoorah&SADAD";
                                      setRequestForm(val);
                                    }}>
                                    <label className={" text-20 font-bold flex flex-row nice-gap-1rem "}>
                                      <input type="radio" checked={paymentType == "Myfatoorah&SADAD" ? true : false} name="paymentType" id="primary" />
                                      {trans("new:online_batch") + " " + trans("new:and_the_rest_via_SADAD")}
                                    </label>
                                    <div className="flex flex-row items-center  mx-10">
                                      <img className="cart-payment-icon object-contain" src="/assets/icons/companies/master-card-3.png" alt={"master"} />
                                      <img className="cart-payment-icon object-contain" src="/assets/icons/companies/visa-3.png" alt={"visa"} />
                                      <img className="cart-payment-icon object-contain" src="/assets/icons/companies/mada-3.png" alt={"mada"} />
                                      <img className="cart-payment-icon object-contain" src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}

                            <ErrorLabel errorTitle={error.paymentType} />
                          </div>
                        </div>
                      }
                      <div className=" grid nice-align-item-center grid-cols-12 gap-5 justify-items-auto p-10   my-20 ">
                        <div className="border-box-periodic-checkInput col-span-12 md:col-span-8 sm:col-span-8 lg:col-span-8 xl:col-span-8"></div>

                        <div className="col-span-12 md:col-span-4 sm:col-span-4 lg:col-span-4 xl:col-span-4">
                          <div
                            className={"btn nice-flex-row  py-5 px-5 text-white text-30 " + (dataFullNum > 3 ? " bg-primary " : " bg-gray ")}
                            onClick={async () => {
                              //// console.log("handlePayment:", stepNum);
                              const num = await checkStepsErrors();
                              // const num = 4;
                              //// console.log("handlePayment:", num);
                              if (num >= stepNum) {
                                //// console.log("handlePayment:", num);
                                // if (stepNum < 4) {
                                setStepNum(4);
                                handlePayment();
                                // }
                              } else {
                                // checkErrors();
                              }
                            }}>
                            {isLoadingSendOrder && (
                              <span className="mx-2 loading-btn ">
                                <img className="object-max-full " alt="" src="/assets/icons/loading.svg" width="25" height="25" />
                              </span>
                            )}
                            {/* //send_sadad_link */}

                            {isReservation ? (paymentType == "Myfatoorah&SADAD" ? trans("new:send_sadad_link") : trans("new:confirm_order")) : trans("new:Pay_Now")}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </form>
              </div>

              {/* //----------------- */}
            </div>
          </div>

          <div className=" hide-xs col-span-0  md:col-span-4 sm:col-span-4 lg:col-span-3 xl:col-span-3 ">
            <div className="carOverview-page-sub pt-20 nice-shadow-3 border-radius bg-white ">
              <div className=" py-10 px-5 ">
                {showFinalPopup !== true && showTimer === true && (
                  <div className="flex flex-col justify-center">
                    <h4 className="text-40 text-bold text-center text-error ">
                      {" "}
                      <CounterOnEnd seconds={600} onEnd={handleTimerEnd} />
                    </h4>
                  </div>
                )}

                <div className="py-5">
                  <h3 className="text-30 text-bold ">{trans("new:orderDetails")}</h3>
                </div>

                <div className="ruler-2 mb-5"></div>
                <div className="carOverview-page-body">
                  {propsData?.vehicle ? (
                    <>
                      <div className="carOverview-page-body-desc">
                        <div className="carOverview-page-body-name">
                          <div className="carOverview-page-body-type">
                            <div className="carOverview-page-body-type-content nice-gap-1rem">
                              <h2 className="text-20 text-bold">{propsData?.vehicle?.brand && propsData?.vehicle?.brand}</h2>
                              {/* <img src={vehicle?.brandIconPath && vehicle?.brandIconPath} /> */}
                              <img alt="" className="" src={`/assets/icons/brands/${(isToyota ? "toyota" : "") + (isLexus ? "lexus" : "")}.webp`} />
                            </div>
                          </div>

                          <h3 className="text-20 text-gray ">
                            {activeModel?.group} {activeModel?.modelDescription} {activeModel?.year}
                          </h3>
                          {carInfo ? (
                            <h3 className={"text-20 text-gray"}>
                              {carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[0] +
                                " / " +
                                carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[1]}
                            </h3>
                          ) : null}
                        </div>
                        {/* <div className="nice-container carOverview-page-body-number flex flex-row nice-gap-1rem my-10">
                                                            <span className="text-20 text-gray"> {trans("new:item_no")}</span>
                                                            <span className="text-20 text-gray">{vehicle?.productNo ? vehicle?.productNo : "########"}</span>
                                                        </div> */}
                      </div>

                      <div className="carOverview-page-body-img">
                        {filterCarImages && filterCarImages[0] && (
                          <img
                            className="carOverview-page-header-img"
                            // src={"data:image;base64," + image.DATA}
                            src={config.FilePathURL + filterCarImages[0]?.Image_URL}
                            alt=""
                          />
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="container search-line my-40">
                      <h4 className="text-gray text-20 py-2">{trans("new:no_data")}</h4>
                    </div>
                  )}
                </div>
                <div className="ruler-2 mb-5"></div>
                <div className="nice-container flex flex-col gap-3 justify-between">
                  <div className="flex flex-col justify-center">
                    {
                      <>
                        <div className="nice-flex nice-flex-row nice-flex-space-between mb-10">
                          <h4 className="text-20">
                            {trans("new:cash_price")}&nbsp;<span className="text-20 text-gray mx-1">{trans("new:price_inclusive_note")}</span>{" "}
                          </h4>
                          <span className="text-20 font-bold text-primary">{carInfo?.NetSalePrice && <Price price={parseFloat(carInfo?.NetSalePrice)} />}</span>
                        </div>
                        {allselectServices && allselectServices.length > 0 && (
                          <div className="nice-flex nice-flex-row nice-flex-space-between mb-10">
                            <h4 className="text-20">
                              {trans("new:accessories")}&nbsp;<span className="text-20 text-gray mx-1">{trans("new:Incloding_VAT")}</span>{" "}
                            </h4>

                            <div dir="ltr" className={"flex text-20 text-error font-bold"}>
                              {" "}
                              {allselectServices?.reduce((total, service) => total + service.Price, 0) ? (
                                <>
                                  {" "}
                                  <Price price={allselectServices?.reduce((total, service) => total + service.Price, 0)} className={"white-space-pre"} />
                                  {" + "}{" "}
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}

                        {SubTotal && (
                          <div className="cart-grid-info-div">
                            <div className={"text-20 text-gray"}>{trans("cartFile:Downpayment")}</div>
                            <div className={"text-20 text-gray font-bold"}>{numberFormat(SubTotal, lang)}</div>
                          </div>
                        )}
                        {develviryType == 1 && (
                          <>
                            {Shipping.CountTime ? (
                              <div className="cart-grid-info-div ">
                                <div className={"text-20 text-gray "}>{trans("cartFile:receive_peroid")}</div>
                                <div className={"text-20 text-gray font-bold"}>
                                  {Shipping.CountTime} {trans("cartFile:" + (trans("cartFile:" + (Shipping.UnitTime ?? "")) ?? ""))}
                                </div>
                              </div>
                            ) : null}
                            {Shipping.CostWithTax ? (
                              <div className="cart-grid-info-div">
                                <div className={"text-20 text-gray"}>{trans("cartFile:shipping_costs")}</div>
                                <div className={"text-20 text-gray font-bold"}>{numberFormat(Shipping.CostWithTax, lang)}</div>
                              </div>
                            ) : null}
                          </>
                        )}
                      </>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Popup show={showFinalPopup}>
        <div className="w-full  flex flex-column justify-center items-center">
          <div className="cart-finalized">
            <div className="cart-finalized-container flex flex-col">
              <div className="cart-finalized-container-img flex flex-col">
                <img src="/assets/images/finalized.svg" alt="" />
              </div>

              <div className="flex flex-wrap justify-center">
                <span className="text-20 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
                <span className="text-20 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
              </div>

              {showFinalPopupMessage && (
                <>
                  <div className="flex mt-10 flex-wrap justify-center mx-20">
                    <span className="text-24 text-gray  mx-2"> {showFinalPopupMessage}</span>
                  </div>
                </>
              )}
              {dataFinalPopup?.InvoiceStatus && (
                <>
                  <div className="flex flex-wrap justify-center mx-20">
                    <span className="text-24 text-gray  mx-2"> {trans("new:payment_status") + ":"}</span>
                    <span className="text-24 text-gray  mx-2"> {dataFinalPopup?.InvoiceStatus}</span>
                  </div>
                </>
              )}
              {dataFinalPopup && (
                <>
                  {dataFinalPopup?.OrderId && (
                    <div
                      className="flex flex-row justify-center cart-finalized-code"
                      onClick={() => {
                        navigator.clipboard.writeText(dataFinalPopup?.OrderId);
                      }}>
                      <span className="text-20 font-bold text-white  mx-2"> {trans("info:order-number") + " :"}</span>
                      <span className="text-20 font-bold text-white  mx-2">{dataFinalPopup?.OrderId && dataFinalPopup?.OrderId}</span>
                      <img src="/assets/icons/copy.svg" alt="" />
                    </div>
                  )}
                </>
              )}

              {sadadInfo && (
                <>
                  <div className="flex mt-10  flex-wrap justify-center mx-20">
                    <span className="text-24 text-center text-gray  mx-2">
                      {" "}
                      {trans("new:a_payment_number_has_already_been_created") + " " + trans("new:to_avoid_order_cancellation") + " " + trans("new:within_24_hours")}
                    </span>
                  </div>

                  <div
                    className="flex cart-finalized-code flex-row nice-align-item-center"
                    onClick={() => {
                      navigator.clipboard.writeText(sadadInfo);
                    }}>
                    <div className=" bg-white border-radius p-1 ">
                      <img className=" object-contain" width={50} height={50} src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />
                    </div>
                    {
                      <div className="flex flex-row justify-center  mt-2">
                        {/* <span className="text-20 font-bold text-white  mx-2"> {trans("new:sadad") + " :"}</span> */}
                        <span className="text-20 font-bold text-white  mx-2">{sadadInfo}</span>
                      </div>
                    }
                    <img src="/assets/icons/copy.svg" alt="" />
                  </div>
                </>
              )}
              {/* <div className="flex flex-center flex-col  mt-5 pt-5 w-80">
                                <div className=" mb-5 w-100">
                                    <div className="nice-sm-btn cart-notification-go  bg-primary text-white text-20" onClick={() => {


                                        if (location.pathname)
                                            history.push("/");

                                    }}>
                                        {trans("cartFile:Continue_browsing")}
                                    </div>
                                </div>
                            </div> */}

              <div
                className="flex nice-flex-center  nice-align-item-center nice-flex-space-between w-100  gap-5 justify-items-auto 
                            py-10 px-20  my-20 ">
                <div className="border-box-periodic-checkInput col-span-12 md:col-span-7 sm:col-span-7 lg:col-span-7 xl:col-span-7">
                  {!orderDraftID && (
                    <div
                      className={"btn nice-flex-row  py-5 px-5 text-white text-24  bg-black"}
                      onClick={async () => {
                        if (location.pathname) history.push("/");
                      }}>
                      {trans("common:home")}
                      <div className={" mx-2 " + (lang == "ar" ? "  " : "rotate-180")}>
                        <svg height="15" width="20" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="#ffffff" stroke="#ffffff">
                          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path
                              d="M14.583 15v1h-7.083c-3.032 0-5.5-2.467-5.5-5.5s2.468-5.5 5.5-5.5h2.912l-2.646-2.646 0.707-0.707 3.853 3.853-3.853 3.854-0.707-0.708 2.646-2.646h-2.912c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5h7.083z"
                              fill="#000000"></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-span-12 md:col-span-5 sm:col-span-5 lg:col-span-5 xl:col-span-5">
                  <div
                    className={"btn nice-flex-row  py-5 px-5 text-white text-24 " + (dataFinalPopup && dataFinalPopup?.OrderId ? " bg-primary " : " bg-gray ")}
                    onClick={async () => {
                      if (dataFinalPopup && dataFinalPopup?.OrderId) history.push("/user/myOrders");
                      else {
                        sn &&
                          slug &&
                          history.push({
                            pathname: `/car/overview/${sn}/${slug}`,
                            search: orderDraftID ? `orderDraftID=${orderDraftID}` : "",
                          });
                      }
                    }}>
                    {dataFinalPopup && dataFinalPopup?.OrderId ? trans("new:order_tracking") : trans("new:Create_New")}
                    <div className={" mx-2 " + (lang == "ar" ? " rotate-180 " : "")}>
                      <svg xmlns="http://www.w3.org/2000/svg" height="15" width="20" viewBox="0 0 448 512">
                        <path
                          fill="#ffffff"
                          strokeWidth="2"
                          d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Popup>

      <Popup show={showStstusLodingPopup && !showFinalPopup}>
        <div className="w-full  flex flex-column justify-center items-center">
          <div className="cart-finalized">
            <div className=" flex flex-column justify-center items-center gap-5">
              <div className=" flex flex-col gap-3">
                <img src="/assets/Loding_new.svg" width={120} height={120} alt="Loding" />

                <span className="text-20 font-bold  text-primary mx-2 unselectable ">{trans("new:thank_you_for_order")}</span>
              </div>

              <div className="flex flex-wrap flex-column justify-center">
                {/* <span className="text-20 font-bold text-blackmx-2"> {trans("new:نقوم الآن بمعالجة الطلب،.")}</span> */}
                <span className="text-20 font-bold text-blackmx-2"> {trans("new:order_number_soon")}</span>
              </div>

              {showFinalPopupMessage && (
                <>
                  <div className="flex mt-10 flex-wrap justify-center mx-20">
                    <span className="text-24 text-gray  mx-2"> {showFinalPopupMessage}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Popup>
      <Popup show={showOTPCheckPopup && !showFinalPopup} key={"OTPCheckPopup"}>
        <div className="w-full  flex flex-column justify-center items-center">
          <div className="cart-finalized">
            <div className="offer-popup-container-header">
              <span
                className="offer-popup-container-header-close text-block text-gray"
                onClick={() => {
                  subFunctionRef.current = null;
                  setShowOTPCheckPopup(false);
                }}></span>
            </div>
            <div className="cart-finalized-container flex flex-col">
              {
                <OTPCheck
                  key={"OTPCheck"}
                  mobile={requestForm?.phoneNumber}
                  setSubFunctionRef={(ref) => {
                    subFunctionRef.current = ref;
                  }} // تخزين المرجع فقط
                  onSucess={async (sucsessData) => {
                    //// console.log("SMS> Click  sucsessData>>>>>>", sucsessData)
                    var codeOtp = sucsessData?.OTP;

                    const val = { ...requestForm };
                    val.OTP = codeOtp;
                    val.verificationOTP = codeOtp;
                    setRequestForm(val);

                    //// console.log("SMS> Click Continue >>>>>>")
                    const num = await checkStepsErrors(val);

                    if (num >= stepNum) {
                      if (stepNum <= 3) {
                        setStepNum(stepNum + 1);
                        handelSaveCachData();
                      }
                    } else {
                      // checkErrors();
                    }

                    subFunctionRef.current = null;
                    setShowOTPCheckPopup(false);
                  }}
                  ResendCode={async () => {
                    SendAbsherOtp();
                  }}
                  goBack={async () => {
                    setStepNum(stepNum - 1);
                    const val = { ...requestForm };
                    val.OTP = "";
                    setRequestForm(val);
                    subFunctionRef.current = null;
                    setShowOTPCheckPopup(false);
                  }}
                />
              }
            </div>
          </div>
        </div>
      </Popup>

      <Popup show={showOTPCheckYakeenDataPopup && !showFinalPopup} key={"OTPCheckYakeenDataPopup"}>
        <div className="w-full  flex flex-column justify-center items-center">
          <div className="cart-finalized">
            <div className="offer-popup-container-header">
              <span
                className="offer-popup-container-header-close text-block text-gray"
                onClick={() => {
                  subOTPCheckYakeenDataFunctionRef.current = null;
                  setShowOTPCheckYakeenDataPopup(false);
                }}></span>
            </div>
            <div className="cart-finalized-container flex flex-col">
              {
                <OTPCheck
                  key={"OTPCheckYakeenData"}
                  mobile={requestForm?.phoneNumber}
                  setSubFunctionRef={(ref) => {
                    subOTPCheckYakeenDataFunctionRef.current = ref;
                  }} // تخزين المرجع فقط
                  onSucess={async (sucsessData) => {
                    //// console.log("SMS> Click  sucsessData>>>>>>", sucsessData)
                    //// console.log("SMS> Click Continue >>>>>>")
                    YakeenGetSaudiData();
                    subOTPCheckYakeenDataFunctionRef.current = null;
                    setShowOTPCheckYakeenDataPopup(false);
                  }}
                  ResendCode={async () => {
                    SendAbsherTPCheckYakeenData();
                  }}
                  goBack={async () => {
                    setStepNum(stepNum - 1);
                    setShowOTPCheckYakeenDataPopup(false);
                  }}
                />
              }
            </div>
          </div>
        </div>
      </Popup>
      {!showFinalPopup && !isLoadingSendOrder && showTimer === true && <ExitPromptHandler />}
    </>
  );
}
